var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _g, _path, _rect, _path2, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _use, _view, _use2, _view2, _use3, _view3, _use4, _view4, _use5, _view5, _use6, _view6, _use7, _view7, _use8, _view8, _use9, _view9, _use10, _view10, _use11, _view11, _use12, _view12, _use13, _view13, _use14, _view14, _use15, _view15, _use16, _view16, _use17, _view17, _use18, _view18, _use19, _view19, _use20, _view20, _use21, _view21, _use22, _view22, _use23, _view23, _use24, _view24, _use25, _view25, _use26, _view26, _use27, _view27, _use28, _view28, _use29, _view29, _use30, _view30, _use31, _view31, _use32, _view32, _use33, _view33, _use34, _view34, _use35, _view35, _use36, _view36, _use37, _view37, _use38, _view38, _use39, _view39, _use40, _view40, _use41, _view41, _use42, _view42, _use43, _view43, _use44, _view44, _use45, _view45, _use46, _view46, _use47, _view47, _use48, _view48, _use49, _view49, _use50, _view50, _use51, _view51, _use52, _view52, _use53, _view53, _use54, _view54, _use55, _view55, _use56, _view56, _use57, _view57, _use58, _view58, _use59, _view59, _use60, _view60, _use61, _view61, _use62, _view62, _use63, _view63, _use64, _view64, _use65, _view65, _use66, _view66, _use67, _view67, _use68, _view68, _use69, _view69, _use70, _view70, _use71, _view71, _use72, _view72, _use73, _view73, _use74, _view74, _use75, _view75, _use76, _view76, _use77, _view77, _use78, _view78, _use79, _view79, _use80, _view80, _use81, _view81, _use82, _view82, _use83, _view83, _use84, _view84, _use85, _view85, _use86, _view86, _use87, _view87, _use88, _view88, _use89, _view89, _use90, _view90, _use91, _view91, _use92, _view92, _use93, _view93;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 15",
    id: "1col",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v15H0z",
    fill: "#979797"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17 10",
    id: "2col",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h7v10H0zM10 0h7v10h-7z"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 27.718 19.579",
    id: "3col",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001 11.281h7.261v8.299H.001zM.001 0h7.261v8.299H.001zM10.153 11.281h7.261v8.299h-7.261zM10.153 0h7.261v8.299h-7.261zM20.306 11.281h7.261v8.299h-7.261zM20.306 0h7.261v8.299h-7.261z"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 37.718 19.579",
    id: "4col",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001 11.281h7.261v8.299H.001zM.001 0h7.261v8.299H.001zM10.153 11.281h7.261v8.299h-7.261zM10.153 0h7.261v8.299h-7.261zM20.306 11.281h7.261v8.299h-7.261zM20.306 0h7.261v8.299h-7.261zM30.458 11.281h7.261v8.299h-7.261zM30.458 0h7.261v8.299h-7.261z"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 47.87 19.579",
    id: "5col",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.457 11.281h7.261v8.299h-7.261zM20.305 11.281h7.261v8.299h-7.261zM10.152 11.281h7.261v8.299h-7.261zM0 11.281h7.261v8.299H0zM30.457 0h7.261v8.299h-7.261zM20.305 0h7.261v8.299h-7.261zM10.152 0h7.261v8.299h-7.261zM0 0h7.261v8.299H0zM40.61 11.281h7.261v8.299H40.61zM40.61 0h7.261v8.299H40.61z"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "accountDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "none",
    stroke: "#a6a6a6",
    strokeWidth: 2,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M14 10H2a2 2 0 00-2 2v3h2v-3h12v3h2v-3a2 2 0 00-2-2z"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "12 12 16 21",
    id: "accountDarkV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v44H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon - my account"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1264",
    transform: "translate(15 12)",
    fill: "none",
    stroke: "#666",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5266",
    fill: "none",
    stroke: "#666",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 23h12a2 2 0 012 2v8H12v-8a2 2 0 012-2z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 24h12a1 1 0 011 1v7h0-14 0v-7a1 1 0 011-1z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5267",
    fill: "#fff",
    d: "M12 31h16v2H12z"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "accountLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 10H2a2 2 0 00-2 2v3h2v-3h12v3h2v-3a2 2 0 00-2-2z"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "alert",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0011b",
    d: "M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8zm1.1 12.2H6.9v-1.9h2.3v1.9zm.1-7.4l-.6 4.4H7.4l-.6-4.4v-1h2.5v1z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 6",
    id: "arrowDown",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.434 5.808L9.82 1.136a.709.709 0 000-.944.6.6 0 00-.883 0L5 4.4 1.063.192a.6.6 0 00-.883 0 .709.709 0 000 .944l4.37 4.672a.6.6 0 00.884 0z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 5",
    id: "arrowDropdown",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l5 5 5-5z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    fill: "#a6a6a6",
    viewBox: "0 0 10 5",
    id: "arrowDropdownLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l5 5 5-5z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 5.088 9.085",
    id: "arrowLeft",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.928 8.155a.545.545 0 01-.771.771l-4-4a.545.545 0 010-.771l4-4a.547.547 0 01.771.776L1.316 4.543z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 5.088 9.085",
    id: "arrowRight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16.931A.545.545 0 01.931.16l4 4a.545.545 0 010 .771l-4 4a.547.547 0 01-.771-.776l3.612-3.612z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 5.088 9.085",
    id: "arrowRightWhite",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16.931A.545.545 0 01.931.16l4 4a.545.545 0 010 .771l-4 4a.547.547 0 01-.771-.776l3.612-3.612z",
    fill: "#fff"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 6",
    id: "arrowUp",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.434.192L9.82 4.864a.709.709 0 010 .944.6.6 0 01-.883 0L5 1.6 1.063 5.808a.6.6 0 01-.883 0 .709.709 0 010-.944L4.55.192a.6.6 0 01.884 0z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 6",
    id: "arrowUpWhite",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFF",
    d: "M5.434.192L9.82 4.864a.709.709 0 010 .944.6.6 0 01-.883 0L5 1.6 1.063 5.808a.6.6 0 01-.883 0 .709.709 0 010-.944L4.55.192a.6.6 0 01.884 0z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25.784 25.784",
    id: "awesomeFont",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M23.935 21.386h-1.243L15.753 2.15A1.7 1.7 0 0014.144 1h-2.5a1.7 1.7 0 00-1.612 1.15l-6.94 19.236H1.849a.849.849 0 00-.849.85v1.7a.849.849 0 00.849.849h6.8a.849.849 0 00.849-.849v-1.7a.849.849 0 00-.849-.849H7.605l1.237-3.4h8.1l1.237 3.4h-1.04a.849.849 0 00-.849.849v1.7a.849.849 0 00.849.849h6.8a.849.849 0 00.849-.849v-1.7a.849.849 0 00-.853-.85zm-13.546-7.644l2.5-6.875 2.5 6.875z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25.784 25.784",
    id: "awesomeFontLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#757676",
    strokeWidth: 2,
    d: "M23.935 21.386h-1.243L15.753 2.15A1.7 1.7 0 0014.144 1h-2.5a1.7 1.7 0 00-1.612 1.15l-6.94 19.236H1.849a.849.849 0 00-.849.85v1.7a.849.849 0 00.849.849h6.8a.849.849 0 00.849-.849v-1.7a.849.849 0 00-.849-.849H7.605l1.237-3.4h8.1l1.237 3.4h-1.04a.849.849 0 00-.849.849v1.7a.849.849 0 00.849.849h6.8a.849.849 0 00.849-.849v-1.7a.849.849 0 00-.853-.85zm-13.546-7.644l2.5-6.875 2.5 6.875z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 53 53",
    id: "badge1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#66b6d1"
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    fill: "#fff",
    fontFamily: "Lato-LightItalic",
    fontSize: "100%"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "51%",
    y: 23
  }, "soft"), /*#__PURE__*/React.createElement("tspan", {
    x: "51%",
    y: 37
  }, "stretch")))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 53 53",
    id: "badge2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#314657"
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    fill: "#fff",
    fontFamily: "Lato-Italic",
    letterSpacing: 0.36,
    fontSize: "78%"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "51%",
    y: 23
  }, "slip"), /*#__PURE__*/React.createElement("tspan", {
    x: "51%",
    y: 37
  }, "resistant")))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 53 53",
    id: "badge3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    fill: "#fff",
    fontFamily: "Lato-LightItalic",
    fontSize: "140%"
  }, "new"))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18.828 13.414",
    id: "btn-icon-success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "btn-icon-success",
    d: "M17.414 1.415l-11 11-5-5",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 27.84",
    id: "carouselPlus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Graphic - Plus",
    d: "M24.079 8.28q2.274.24 4.609.48a36.587 36.587 0 014.429.72 22.179 22.179 0 013.891 1.26 7.94 7.94 0 012.993 2.22 1.963 1.963 0 00-.479.06.674.674 0 01-.479-.06 6.4 6.4 0 01-1.736.42q-.778.06-1.855.06-.239 0-.239.06t-.239.18a.424.424 0 00-.359-.06.832.832 0 01-.359.06v.12l-.12.12a2.007 2.007 0 00-1.556.12 6.609 6.609 0 01-1.317.6 1.664 1.664 0 00-.718.12 1.918 1.918 0 00-1.377.24 1.6 1.6 0 01-1.377.12.383.383 0 01-.359.24.212.212 0 00-.239.24q-.838-.24-1.077.12h-.599q-.12 0-.359.24a6.283 6.283 0 00-3.232.84 17.268 17.268 0 00-1.736.3q-.778.18-1.975.42a1.2 1.2 0 00-.3.72 1.2 1.2 0 01-.3.72q-.239-.12 0-.18t.12-.3q-.359.24-.6 1.44a.919.919 0 00-.418.66 1.869 1.869 0 01-.3.78 2.379 2.379 0 00-.958 1.8q-.12-.12-.12 0t-.239.12a3.217 3.217 0 01-.239 1.2 1.516 1.516 0 01-.718.84q.12.24-.06.36t-.06.36q-.239 0-.18-.18t-.18-.18q.12.24-.359.72a2.073 2.073 0 01-1.077 1.44 20.656 20.656 0 01-.12-4.98 43 43 0 01.718-4.86 12.294 12.294 0 00-2.933.9 9.7 9.7 0 01-3.292.78q-.479 0-.479.24-.12.12-.12 0a.106.106 0 00-.12-.12.49.49 0 00-.12.36 2.966 2.966 0 00-1.077-.12 6.585 6.585 0 01-2.394-2.52q-.838-1.56-1.556-3.24a.212.212 0 00-.239-.24 3.237 3.237 0 00-.18-1.02q-.18-.54-.3-1.02.239-.24.06-.36t.06-.6q.239.12.3.06t.3.06q3.472-.96 7.123-1.68a57.362 57.362 0 017.721-.96 37.005 37.005 0 001.676-3.9A23.682 23.682 0 0118.931.96a1.675 1.675 0 01.12-.72 1.834 1.834 0 00.718-.24 6.711 6.711 0 001.317.12 3.28 3.28 0 00.419.18 1.323 1.323 0 00.419.06 4.081 4.081 0 012.215 1.14 10.547 10.547 0 011.5 1.86 3.206 3.206 0 01-.18 2.4 18.213 18.213 0 00-1.018 2.16.106.106 0 00-.12.12q-.004.12-.242.24zm-9.936.96h.239a.106.106 0 00-.12-.12zm-.239 0q-.12-.12-.12 0zm1.077.24q.239-.12.239-.06t.12.06v-.24a.383.383 0 00-.359.24zm-.6-.12h-.239a.106.106 0 00-.12.12q.36 0 .36-.12zm-2.274.84a.345.345 0 01-.239.12 10.2 10.2 0 00-2.095.24q-1.137.24-2.215.48a.832.832 0 01.359.06.832.832 0 00.359.06 6.828 6.828 0 012.035-.42 5.616 5.616 0 001.915-.42 2.179 2.179 0 001.137-.06 1.281 1.281 0 011.018.06q.12-.24 0-.18a.2.2 0 01-.239-.06q.12-.24.239-.12t.239-.12q-.239-.12-.359 0t-.359 0q0-.24.3-.18t.18-.18a.6.6 0 01-.718 0 1.64 1.64 0 01-1.2.24 1.426 1.426 0 00-1.2.36v-.24a.487.487 0 00-.359.12q-.12.12-.359 0v.12l-.12.12v-.24q-.239.12-.3.06t-.3.18q0-.24-.12-.24a.276.276 0 00-.3.18q-.06.18-.3.06a.106.106 0 01-.12.12 1.863 1.863 0 01-1.317 0 .605.605 0 00.718.24 3.267 3.267 0 01.718-.12 10.361 10.361 0 001.437-.12q.838-.12 1.437-.24a.106.106 0 01.129.12zm-6.105.72q-.239-.24-.239-.06t.239.06zm1.437.12a.106.106 0 00-.12.12zm-.6.24a.487.487 0 00.359-.12q-.358-.12-.358.12zm-.12 0zm6.105-1.2a.345.345 0 01-.239.12q0-.24.12-.24a.106.106 0 01.121.12zm0 0a1.963 1.963 0 00.479-.06 1.963 1.963 0 01.479-.06.291.291 0 01-.359.18 2.512 2.512 0 00-.597-.06zm1.077 0q.12-.24.12-.06t-.118.06zm-1.8.12q.239 0 .3-.12t.18.12zm15.569 5.28q0-.12.06-.06t.06-.06z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16.667 16.667",
    id: "chat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M15 0H1.666A1.672 1.672 0 000 1.666v15l3.333-3.333H15a1.672 1.672 0 001.667-1.667v-10A1.672 1.672 0 0015-.001zm0 11.667H3.333l-1.667 1.666V1.666H15v10z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "checkbox",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ddd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 6.5l-6.875 7L5 10.318",
    opacity: 0.002
  })))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "checkboxSelected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#404040",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 6.5l-6.875 7L5 10.318"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "checkmark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.11 -.307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-.11 .307)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 11.863L4.224 9.337l1.263-1.263L6.75 9.337l3.789-3.789 1.263 1.265z"
  })))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "checkmarkLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.11 -.307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#fff",
    transform: "translate(-.11 .307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.863L4.224 9.337l1.263-1.263L6.75 9.337l3.789-3.789 1.263 1.265z"
  })))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "checkmarkNoCircle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.863L4.224 9.337l1.263-1.263L6.75 9.337l3.789-3.789 1.263 1.265z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 9.333 9.333",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.394 9.334l.94-.94-3.727-3.727L9.334.94 8.394 0 4.667 3.727.94 0 0 .94l3.727 3.727L0 8.394l.94.94 3.727-3.727z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15.998 16",
    id: "embroideryNeedle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.038 12.9a2.347 2.347 0 010-3.315 3.285 3.285 0 000-4.641l-.332-.332.2-.2a2.5 2.5 0 00.141-3.435l-.024-.024a2.5 2.5 0 00-3.432.141l-.2.2-.328-.332a3.28 3.28 0 00-4.641 0 2.347 2.347 0 01-3.315 0L2.441.3a.469.469 0 10-.663.663l.663.663a3.285 3.285 0 004.641 0 2.343 2.343 0 013.315 0l.346.346c-1.156 1.27-2.451 3-3.81 4.819-3.986 5.328-3.613 4.536-6.822 8.437a.469.469 0 00.661.661c3.9-3.209 3.105-2.833 8.439-6.822 1.818-1.359 3.548-2.654 4.819-3.81l.346.346a2.347 2.347 0 010 3.315 3.285 3.285 0 000 4.641l.663.663a.469.469 0 00.663-.663zm-.8-9.15l-.288.288a54.339 54.339 0 01-5.302 4.278c-1.428 1.068-2.9 2.168-4.224 3.26 1.092-1.326 2.192-2.8 3.26-4.224 1.334-1.784 2.606-3.484 3.723-4.716l.648.648-.995.995a.469.469 0 00.663.663l1.989-1.989a.469.469 0 10-.663-.663l-.332.332-.663-.663.2-.2a1.555 1.555 0 012.118-.129 1.555 1.555 0 01-.13 2.116z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 21.333 26.167",
    id: "featherFlag",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.708S2.208 15.5 5.833 15.5s6.042 2.417 9.667 2.417 4.833-1.208 4.833-1.208V2.208S19.125 3.416 15.5 3.416 9.459 1 5.834 1 1 2.208 1 2.208zM1 25.166v-8.458"
  })))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 21.333 26.167",
    id: "featherFlagLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#757676",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.708S2.208 15.5 5.833 15.5s6.042 2.417 9.667 2.417 4.833-1.208 4.833-1.208V2.208S19.125 3.416 15.5 3.416 9.459 1 5.834 1 1 2.208 1 2.208zM1 25.166v-8.458"
  })))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26.167 23.75",
    id: "featherFolder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.166 20.333a2.417 2.417 0 01-2.417 2.417H3.416a2.417 2.417 0 01-2.417-2.417V3.417A2.417 2.417 0 013.416 1h6.042l2.417 3.625H22.75a2.417 2.417 0 012.417 2.417z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26.167 23.75",
    id: "featherFolderLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#757676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.166 20.333a2.417 2.417 0 01-2.417 2.417H3.416a2.417 2.417 0 01-2.417-2.417V3.417A2.417 2.417 0 013.416 1h6.042l2.417 3.625H22.75a2.417 2.417 0 012.417 2.417z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24.405 24.405",
    id: "featherImage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2,
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.444 1h17.112A2.444 2.444 0 0123 3.444v17.112A2.444 2.444 0 0120.556 23H3.444A2.444 2.444 0 011 20.556V3.444A2.444 2.444 0 013.444 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.167 7.917a2.25 2.25 0 11-2.25-2.25 2.25 2.25 0 012.25 2.25zM23 14l-5.937-7.5L4 23"
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24.405 24.405",
    id: "featherImageLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#757676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.444 1h17.112A2.444 2.444 0 0123 3.444v17.112A2.444 2.444 0 0120.556 23H3.444A2.444 2.444 0 011 20.556V3.444A2.444 2.444 0 013.444 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.167 7.917a2.25 2.25 0 11-2.25-2.25 2.25 2.25 0 012.25 2.25zM23 14l-5.937-7.5L4 23"
  })))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 13 12",
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5H12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5h2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(6.5 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5h7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1.5 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5h1M0 1.5h6.5M0 9.5h6"
  })))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "footerPinterest",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "pinterest",
    d: "M15 30A15 15 0 014.394 4.394a15 15 0 1121.213 21.213A14.9 14.9 0 0115 30zm-.915-18.945c-.9 0-1.6.94-1.6 2.141a3.2 3.2 0 00.264 1.309c0 .009-.916 3.867-1.068 4.509a8.646 8.646 0 00-.032 3.1l.006.04a.106.106 0 00.108.092.114.114 0 00.09-.044l.024-.031a8.506 8.506 0 001.475-2.671c.1-.362.58-2.256.585-2.275a2.383 2.383 0 002.03 1.032 4.047 4.047 0 003.244-1.618 6.609 6.609 0 001.24-4.052 4.96 4.96 0 00-5.262-4.741 6.044 6.044 0 00-4.45 1.7 4.992 4.992 0 00-1.489 3.468 3.184 3.184 0 001.7 3.161.4.4 0 00.142.029.28.28 0 00.273-.237l.116-.452.054-.212a.4.4 0 00-.119-.461 2.39 2.39 0 01-.548-1.622 3.942 3.942 0 011.1-2.766 4.053 4.053 0 012.99-1.2c2.1 0 3.458 1.245 3.458 3.171 0 2.508-1.133 4.4-2.635 4.4a1.368 1.368 0 01-1.088-.5 1.256 1.256 0 01-.224-1.092c.09-.378.211-.767.328-1.144a6.924 6.924 0 00.406-1.794 1.111 1.111 0 00-1.118-1.24z"
  })))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 35 35",
    id: "fyl-prints-icon",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "FYL color wheel icon 35 x 35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(14.35)",
    fill: "#f32e15"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(14.35 28.7)",
    fill: "#65c8ae"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 3.115,
    cy: 3.115,
    r: 3.115,
    transform: "translate(21.77 1.82)",
    fill: "#ed0d4c"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 10",
    cx: 3.115,
    cy: 3.115,
    r: 3.115,
    transform: "translate(21.77 27.09)",
    fill: "#5acbeb"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 3.115,
    cy: 3.115,
    r: 3.115,
    transform: "translate(7 1.82)",
    fill: "#fc751e"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 3.115,
    cy: 3.115,
    r: 3.115,
    transform: "translate(7 27.09)",
    fill: "#64bf3c"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(27.3 7.28)",
    fill: "#cb469d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(27.3 21.63)",
    fill: "#434eaa"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(1.4 7.28)",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(1.4 21.63)",
    fill: "#8ac938"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(28.7 14.49)",
    fill: "#8e4da0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3.15,
    cy: 3.15,
    r: 3.15,
    transform: "translate(0 14.49)",
    fill: "#bfda01"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.98 -13.613 41.127)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 1.814,
    cy: 1.814,
    r: 1.814,
    transform: "translate(8.493)",
    fill: "#f32e15"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 1.814,
    cy: 1.814,
    r: 1.814,
    transform: "translate(8.529 16.87)",
    fill: "#65c8ae"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(12.82 1.064)",
    fill: "#ed0d4c"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 10",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(12.852 15.965)",
    fill: "#5acbeb"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(4.1 1.045)",
    fill: "#fc751e"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(4.132 15.946)",
    fill: "#64bf3c"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(16.106 4.304)",
    fill: "#cb469d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(16.124 12.739)",
    fill: "#434eaa"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(.828 4.271)",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(.846 12.706)",
    fill: "#8ac938"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(16.952 8.524)",
    fill: "#8e4da0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(0 8.487)",
    fill: "#bfda01"
  }))))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 12.67",
    id: "googlePlus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.368A6.2 6.2 0 013.713.537a6.312 6.312 0 016.862 1.167L8.821 3.342a3.593 3.593 0 00-2.556-.943 3.865 3.865 0 00-3.809 3.97 3.948 3.948 0 003.909 3.969 3.352 3.352 0 003.609-2.729H6.365V5.277h6.014l.1 1.191a5.876 5.876 0 01-6.115 6.2A6.343 6.343 0 010 6.368zm16.289 2.679V6.864h-2.205V5.375h2.205V3.191h1.5v2.184H20v1.489h-2.205v2.183z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30.621 30.621",
    id: "icon-feather-zoom-in",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5a12 12 0 11-12-12 12 12 0 0112 12zM28.5 28.5l-6.525-6.525M13.5 9v9M9 13.5h9"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30.621 30.621",
    id: "icon-feather-zoom-out",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5a12 12 0 11-12-12 12 12 0 0112 12zM28.5 28.5l-6.525-6.525M9 13.5h9"
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30.621 30.621",
    id: "icon-feather-zoom-outLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.5a12 12 0 11-12-12 12 12 0 0112 12zM28.5 28.5l-6.525-6.525M9 13.5h9"
  })))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 74",
    id: "irregular-badge",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Bubble - Irregular",
    transform: "translate(-.394 -.113)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1240",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(.394 .113)",
    fill: "#ffd83c"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(37.394 43.113)",
    fontSize: 17,
    fontFamily: "Lato-Italic, Lato",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.457,
    y: 0
  }, "irregular"))))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H0V0h20v20zM12.118 9.573c.859 0 1.294.6 1.294 1.777v4.15H16v-4.466c0-2.235-1.087-3.517-2.981-3.517a2.578 2.578 0 00-2.275 1.2V7.674H8.195v7.824h2.549v-4.727a1.414 1.414 0 011.374-1.198zm-7.922-1.9v7.824h2.549V7.673zm1.255-3.676a1.458 1.458 0 00-1.45 1.463 1.458 1.458 0 001.45 1.461 1.458 1.458 0 001.45-1.461A1.458 1.458 0 005.451 4z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 543.999 54.15",
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.659 45.702c-7.26 0-11.9-4-11.9-12.393V8.966h7.5v24.391c0 3.507 1.533 5.581 4.642 5.581 3.059 0 4.495-2.074 4.495-5.581V8.966h7.51v24.343c0 8.488-4.889 12.393-12.245 12.393M156.339 45.157l-14.547-18.56v18.56h-7.357l.05-36.189h2.709l14.275 18.119V8.967h7.406v36.19zM165.104 8.966h7.501v36.189h-7.501zM186.301 15.879v8.542h9.48v6.664h-9.48v14.072h-7.507V8.967h18.607v6.913zM213.786 45.702c-8.541 0-13.874-7.411-13.874-18.616s5.482-18.663 14.22-18.663c8.541 0 13.879 7.307 13.879 18.564 0 11.208-5.533 18.715-14.225 18.715m.149-30.663c-3.9 0-6.17 4.494-6.17 12 0 7.453 2.269 12.1 6.17 12.1s6.218-4.644 6.218-12.1c0-7.505-2.317-12-6.218-12M282.324 45.157l-.395-17.771-6.857 11.948h-1.188l-7.062-11.948-.3 17.771h-7.208l1.157-36.189h2.738l11.412 18.809 11.123-18.809h2.6l1.238 36.189zM249.686 30.492a11.381 11.381 0 005.184-10.07c0-6.372-4.2-11.753-13.826-11.753a62.855 62.855 0 00-8.292.545v35.938h7.5V15.633a11.151 11.151 0 011.88-.149c3.305 0 5.083 2.024 5.083 5.382 0 3.745-2.984 5.589-6.225 5.69l6.817 18.6h8.2zM338.194 45.496a60.48 60.48 0 01-7.962-.543V9.197a66.329 66.329 0 017.816-.545c11.819 0 17.806 6.977 17.806 18.15 0 11.375-5.839 18.694-17.66 18.694m1.435-30.017c-.741 0-1.186.051-1.877.1v22.992a12.878 12.878 0 002.126.15c5.342 0 8.108-4.649 8.108-11.871 0-7.07-3.065-11.372-8.357-11.372M451.969 15.922v29.276h-7.52V15.922h-7.568V8.957h22.628v6.97zM507.392 24.382v18.4a18.017 18.017 0 01-10.237 2.967c-8.507 0-14.935-6.776-14.935-18.544 0-11.178 6.33-18.794 15.33-18.794a16.206 16.206 0 019.248 2.918l-2.966 6.181a10.94 10.94 0 00-6.033-2.074c-4.947 0-7.716 4.6-7.716 11.717 0 7.813 3.215 12.017 7.467 12.017a6.353 6.353 0 002.87-.493v-7.715h-4.611v-6.575zM315.662 8.952h-3.644l-12.1 36.246h7.418l1.928-6.279h8.952l1.929 6.279h7.565zm-4.516 23.786l2.619-9.793 2.571 9.793zM394.455 8.952h-3.644l-12.1 36.246h7.42l1.931-6.279h8.948l1.932 6.279h7.562zm-4.516 23.786l2.619-9.793 2.574 9.793zM470.851 8.952h-3.646l-12.1 36.246h7.421l1.929-6.279h8.952l1.925 6.279h7.571zm-4.519 23.786l2.62-9.793 2.573 9.793zM371.624 45.199L383.43 8.957h-8.012l-5.72 21.213-5.724-21.213h-8.107l11.757 36.246zM433.113 45.199V8.957h-7.416v18.147L411.336 8.957h-2.7v36.246H416V26.604l14.518 18.595zM539.703 8.952a4.293 4.293 0 11-4.291 4.3 4.295 4.295 0 014.291-4.3m3.239 4.3a3.242 3.242 0 10-3.239 3.366 3.3 3.3 0 003.239-3.366m-3.5.382h-.73v2.068h-.856v-4.9h1.91c1.215 0 1.839.415 1.839 1.41a1.331 1.331 0 01-1.262 1.385l1.345 2.106h-1zm.152-.72c.61 0 1.155-.057 1.155-.741 0-.563-.6-.66-1.089-.66h-.948v1.4zM47.087 54.14L65.155 0H46.098v33.4c0 11.629-5.3 18.961-14.7 20.75h15.683zM27.014 41.653c3.942 0 5.94-2.749 5.94-8.169V4.274L45.554 0h-24.71v33.484c0 5.42 2.077 8.169 6.169 8.169M74.586 33.475l-3.692-12.75-4.53 15.522zM7.699 33.398v-33.4h-7.7v54.148h22.006c-9.152-1.79-14.307-9.121-14.307-20.751M80.567 54.14l-2.842-9.812-15.212 5.131-1.364 4.681v.009h19.422zM94.867 54.14V0h-18zM512.338 45.205V8.946h18.8v6.922h-11.28v7.47h9.675v6.63h-9.675v8.312h11.278v6.925z"
  })))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 180 39.902",
    id: "logoFooterPrimary",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.224 39.652L47.36.295H33.51V24.57c0 8.453-3.85 13.784-10.685 15.086h11.399zM19.637 30.571c2.866 0 4.318-2 4.318-5.939V3.401L33.116.295H15.153v24.341c0 3.941 1.508 5.939 4.484 5.939M54.217 24.63l-2.685-9.271-3.29 11.286zM5.598 24.57V.29h-5.6v39.37h16c-6.653-1.3-10.4-6.632-10.4-15.086M58.568 39.652l-2.066-7.132-11.059 3.73-.991 3.4v.008h14.121zM68.964 39.653V.296H55.88zM81.075 20.25c-3.943 0-6.465-2.173-6.465-6.732V.295h4.076v13.249c0 1.9.833 3.031 2.523 3.031 1.662 0 2.44-1.127 2.44-3.031V.295h4.076v13.223c0 4.612-2.655 6.732-6.65 6.732M102.629 19.955l-7.9-10.084v10.084h-4l.027-19.66h1.472l7.755 9.843V.295h4.023v19.66zM107.389.295h4.075v19.66h-4.075zM118.902 4.05v4.641h5.15v3.619h-5.15v7.645h-4.078V.295h10.112v3.754zM133.835 20.25c-4.64 0-7.538-4.024-7.538-10.112S129.275 0 134.023 0c4.64 0 7.538 3.97 7.538 10.084 0 6.089-3 10.166-7.726 10.166m.081-16.656c-2.119 0-3.352 2.44-3.352 6.517 0 4.05 1.233 6.571 3.352 6.571s3.378-2.521 3.378-6.571c0-4.077-1.26-6.517-3.378-6.517M171.065 19.955l-.215-9.655-3.726 6.49h-.645l-3.835-6.49-.162 9.655h-3.916l.629-19.66h1.488l6.2 10.218L172.925.295h1.415l.671 19.66zM153.335 11.988a6.183 6.183 0 002.815-5.471c0-3.46-2.279-6.384-7.509-6.384a34.441 34.441 0 00-4.505.3v19.526h4.076V3.919a6.242 6.242 0 011.02-.079c1.8 0 2.762 1.1 2.762 2.922 0 2.035-1.622 3.036-3.382 3.092l3.7 10.1h4.454zM178.125.28a1.874 1.874 0 11-1.874 1.875A1.876 1.876 0 01178.125.28m1.414 1.875a1.415 1.415 0 10-1.414 1.47 1.44 1.44 0 001.414-1.47m-1.529.167h-.319v.9h-.373v-2.14h.835c.529 0 .8.181.8.616a.581.581 0 01-.55.605l.586.919h-.44zm.066-.314c.266 0 .5-.025.5-.323 0-.246-.263-.288-.475-.288h-.414v.611zM91.184 39.794a26.359 26.359 0 01-3.459-.236V24.025a28.44 28.44 0 013.394-.237c5.135 0 7.735 3.03 7.735 7.886 0 4.941-2.534 8.121-7.67 8.121m.622-13.042c-.321 0-.515.023-.816.044v9.99a5.588 5.588 0 00.923.066c2.321 0 3.525-2.02 3.525-5.157 0-3.072-1.332-4.942-3.633-4.942M140.615 26.945v12.721h-3.265V26.945h-3.288v-3.029h9.831v3.028zM164.694 30.619v7.993a7.838 7.838 0 01-4.448 1.289c-3.7 0-6.489-2.944-6.489-8.058 0-4.855 2.75-8.165 6.661-8.165a7.041 7.041 0 014.017 1.268l-1.289 2.687a4.752 4.752 0 00-2.621-.9c-2.149 0-3.352 2-3.352 5.091 0 3.4 1.4 5.222 3.245 5.222a2.75 2.75 0 001.246-.215v-3.352h-2v-2.858zM166.845 39.666v-15.75h8.164v3.007h-4.9v3.245h4.2v2.879h-4.2v3.61h4.9v3.008zM81.394 23.916h-1.582l-5.257 15.75h3.223l.837-2.73h3.891l.837 2.73h3.288zm-1.962 10.335l1.139-4.255 1.118 4.255zM115.626 23.916h-1.582l-5.257 15.75h3.221l.839-2.73h3.888l.838 2.73h3.286zm-1.962 10.335l1.139-4.255 1.118 4.255zM148.817 23.916h-1.582l-5.257 15.75h3.223l.838-2.73h3.884l.838 2.73h3.286zm-1.961 10.335l1.139-4.255 1.116 4.255zM105.707 39.666l5.128-15.749h-3.479l-2.487 9.217-2.486-9.217H98.86l5.107 15.749zM132.423 39.666v-15.75H129.2v7.885l-6.241-7.885h-1.17v15.75h3.2v-8.08l6.307 8.08z"
  })))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 190.268 39.466",
    id: "logoFooterPrimaryChefUniform",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.098 22.422a4.44 4.44 0 01-4.371 4.453c-2.105 0-4.534-1.026-4.534-4.534V11.765a4.3 4.3 0 014.48-4.426 4.369 4.369 0 014.425 4.588v1.079h-2.752v-.918a1.808 1.808 0 00-1.7-2c-1.376 0-1.7.945-1.7 2.24v9.824c0 1.107.431 1.971 1.673 1.971a1.7 1.7 0 001.727-1.943v-.945h2.752zM83.836 7.497h2.752v6.855h.054a2.907 2.907 0 012.59-1.484c1.376 0 2.834.891 2.834 3.346v10.5h-2.753v-9.473c0-1-.485-1.619-1.349-1.619-1.026 0-1.376.675-1.376 1.889v9.2h-2.752zM96.499 20.91v1.862a1.236 1.236 0 001.35 1.35c1.052 0 1.3-.783 1.349-1.377h2.753a4.2 4.2 0 01-1.107 2.915 4.015 4.015 0 01-3 1.214 3.919 3.919 0 01-3.59-1.97 6.028 6.028 0 01-.513-2.78v-4.507a6.023 6.023 0 01.513-2.779 3.919 3.919 0 013.59-1.97 4 4 0 014.1 4.264v3.778zm0-2.159h2.7v-1.565c0-1.026-.513-1.565-1.349-1.565s-1.35.54-1.35 1.565zM104.275 15.189h-1.35V13.03h1.35v-1.862a3.343 3.343 0 013.535-3.671h1.269v2.591h-1.242c-.513 0-.81.351-.81.945v2h2.052v2.159h-2.052v11.52h-2.752z",
    fill: "#ec1b3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2 22.827a4.454 4.454 0 11-8.907 0v-14.9h2.753v14.628c0 1.35.729 2 1.7 2s1.7-.648 1.7-2V7.93h2.754zM121.213 13.463h2.753v1.322h.054a2.909 2.909 0 012.591-1.484c1.377 0 2.834.891 2.834 3.346v10.5h-2.753v-9.473c0-1-.485-1.619-1.349-1.619-1.026 0-1.376.675-1.376 1.889v9.2h-2.753zM131.313 7.93h2.753v2.755h-2.753zm0 5.533h2.753v13.682h-2.753zM136.646 15.622h-1.35v-2.159h1.35v-1.862a3.344 3.344 0 013.536-3.671h1.27v2.591h-1.241c-.513 0-.81.351-.81.945v2h2.051v2.159h-2.051v11.52h-2.752zM142.236 18.051a6.029 6.029 0 01.512-2.779 4.255 4.255 0 017.179 0 6.017 6.017 0 01.513 2.779v4.507a6.022 6.022 0 01-.513 2.78 4.255 4.255 0 01-7.179 0 6.034 6.034 0 01-.512-2.78zm2.753 4.939c0 1.025.512 1.565 1.349 1.565s1.35-.54 1.35-1.565v-5.371c0-1.026-.513-1.565-1.35-1.565s-1.349.54-1.349 1.565zM152.14 13.463h2.753v1.458a5.028 5.028 0 013.643-1.619v2.915a2.2 2.2 0 00-.836-.162 2.746 2.746 0 00-2.807 2.969v8.123h-2.753zM159.691 13.463h2.753v1.322h.054a2.907 2.907 0 012.59-1.484 3 3 0 012.456 1.376 3.459 3.459 0 012.861-1.376c1.376 0 3 .891 3 3.346v10.5h-2.753v-9.473c0-1-.486-1.619-1.35-1.619-1.026 0-1.377.675-1.377 1.889v9.2h-2.755v-9.473c0-1-.485-1.619-1.349-1.619-1.026 0-1.376.675-1.376 1.889v9.2h-2.753zM180.379 17.295a1.359 1.359 0 00-1.4-1.4 1.324 1.324 0 00-1.349 1.376c0 .512.135 1 1.161 1.4l1.619.647a3.811 3.811 0 012.7 3.859 4.055 4.055 0 01-4.1 4.129 3.985 3.985 0 01-4.1-4.129h2.591c.108.756.458 1.539 1.484 1.539a1.491 1.491 0 001.531-1.488c0-.755-.324-1.268-1.377-1.673l-1.322-.486a3.893 3.893 0 01-2.78-3.778 3.963 3.963 0 014.048-3.994 3.862 3.862 0 013.886 3.994z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ec1b3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.762 10.995v1.118h-1.118v-1.118zM186.245 14.082a.5.5 0 00-.549.548c0 .428.319.526.56.548v1.118a1.707 1.707 0 01-1.184-.449 1.634 1.634 0 01-.494-1.217 1.591 1.591 0 01.8-1.458 2.44 2.44 0 011.129-.208h1.83a2.445 2.445 0 011.13.208 1.591 1.591 0 01.8 1.458 1.63 1.63 0 01-1.776 1.666v-1.118c.449 0 .658-.208.658-.548s-.219-.548-.636-.548zM188.338 16.909a2.451 2.451 0 011.13.208 1.729 1.729 0 010 2.916 2.451 2.451 0 01-1.13.208h-1.83a2.445 2.445 0 01-1.129-.208 1.728 1.728 0 010-2.916 2.445 2.445 0 011.129-.208zm-2.005 1.118c-.417 0-.637.208-.637.548s.22.548.637.548h2.181c.417 0 .636-.208.636-.548s-.219-.548-.636-.548zM190.202 21.023v1.118h-.537v.022a1.18 1.18 0 01.6 1.052 1.218 1.218 0 01-.559 1 1.406 1.406 0 01.559 1.162 1.213 1.213 0 01-1.359 1.217h-4.262v-1.118h3.848c.406 0 .658-.2.658-.548 0-.416-.274-.559-.768-.559h-3.738v-1.118h3.848c.406 0 .658-.2.658-.548 0-.417-.274-.559-.768-.559h-3.738v-1.118z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h68.522v39.466H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.743 23.432H21.784c-6.671 0-11.9-3.882-11.9-8.837V8.159H32.74v3.89H13.776v2.546c0 2.727 3.593 4.946 8.008 4.946h10.959zM69.027 8.159h-14.23v6.436c0 2.727-3.592 4.946-8.008 4.946h-7.1V8.159h-3.891v15.273h10.99c6.673 0 11.9-3.882 11.9-8.837v-2.546h10.339z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.676 31.29S57.545 27.355 54 27.355H14.562c-3.546 0-4.676 3.935-4.676 3.935z",
    fill: "#ec1b3e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.07 31.29v-1.315h-.5v-.229h1.261v.229h-.5v1.315zm1.028 0v-1.544h.379l.391 1.233.376-1.233h.371v1.544h-.235v-1.3l-.4 1.3h-.229l-.415-1.315v1.315z",
    fill: "#ec1b3e"
  })))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 282.851 40.332",
    id: "logoFooterPrimaryCorpSolutions",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.196 39.618L47.321.295h-13.84v24.259c0 8.446-3.847 13.772-10.676 15.072h11.391zM19.62 30.548c2.863 0 4.315-2 4.315-5.934V3.398l9.153-3.1H15.14v24.319c0 3.935 1.508 5.931 4.48 5.931zM54.169 24.609l-2.683-9.263L48.2 26.619zM5.593 24.554V.295H0v39.331h15.984C9.336 38.325 5.593 32.999 5.593 24.554zM58.517 39.618l-2.064-7.126-11.049 3.727-.99 3.4v.008h14.108zM68.903 39.618V.295H55.831z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.004 20.232c-3.94 0-6.459-2.171-6.459-6.727V.295h4.076v13.237c0 1.9.832 3.029 2.521 3.029 1.66 0 2.438-1.126 2.438-3.029V.295h4.072v13.211c-.003 4.608-2.656 6.726-6.648 6.726zM102.54 19.937l-7.9-10.075v10.075h-3.992L90.674.295h1.47l7.748 9.834V.295h4.021v19.642zM107.295 19.937V.295h4.071v19.642zM118.798 4.046v4.637h5.145v3.616h-5.145v7.638h-4.074V.295h10.1v3.751zM133.718 20.232c-4.636 0-7.531-4.021-7.531-10.1S129.163 0 133.906 0c4.636 0 7.531 3.966 7.531 10.075 0 6.084-3.002 10.157-7.719 10.157zm.081-16.642c-2.117 0-3.349 2.438-3.349 6.512 0 4.046 1.232 6.565 3.349 6.565s3.375-2.519 3.375-6.565c0-4.073-1.258-6.511-3.375-6.511zM170.916 19.937l-.214-9.647-3.723 6.488h-.644l-3.832-6.484-.161 9.647h-3.912l.628-19.642h1.486l6.193 10.209L172.774.299h1.412l.671 19.642zM153.202 11.978a6.178 6.178 0 002.813-5.466c0-3.457-2.277-6.378-7.5-6.378a34.381 34.381 0 00-4.5.3v19.509h4.073V3.913a6.208 6.208 0 011.019-.079c1.8 0 2.76 1.1 2.76 2.92 0 2.034-1.621 3.034-3.379 3.089l3.7 10.1h4.449zM177.969.28a1.873 1.873 0 11-1.872 1.873A1.873 1.873 0 01177.969.28m1.413 1.873a1.414 1.414 0 10-1.413 1.469 1.44 1.44 0 001.413-1.469m-1.528.167h-.319v.9h-.373V1.087h.833c.529 0 .8.181.8.615a.581.581 0 01-.55.6l.586.918h-.435zm.066-.314c.266 0 .5-.025.5-.323 0-.246-.263-.288-.475-.288h-.414v.611zM91.104 39.759a26.306 26.306 0 01-3.456-.235v-15.52a28.481 28.481 0 013.391-.237c5.131 0 7.728 3.027 7.728 7.879.001 4.937-2.536 8.113-7.663 8.113zm.622-13.031c-.322 0-.515.023-.815.044v9.982a5.608 5.608 0 00.922.066c2.319 0 3.522-2.019 3.522-5.153.001-3.07-1.33-4.939-3.624-4.939zM140.492 26.922v12.706h-3.263V26.922h-3.285v-3.026h9.822v3.026zM164.55 30.593v7.986a7.83 7.83 0 01-4.444 1.288c-3.693 0-6.483-2.942-6.483-8.051 0-4.851 2.748-8.157 6.655-8.157a7.035 7.035 0 014.014 1.266l-1.289 2.685a4.749 4.749 0 00-2.618-.9c-2.147 0-3.349 2-3.349 5.087 0 3.392 1.394 5.217 3.241 5.217a2.751 2.751 0 001.245-.215V33.45h-2v-2.855zM166.699 39.628V23.896h8.157v3h-4.896v3.242h4.2v2.876h-4.2v3.614h4.894v3zM81.323 23.896h-1.584l-5.25 15.732h3.22l.836-2.727h3.887l.836 2.727h3.285zm-1.961 10.325L80.5 29.97l1.117 4.251zM115.526 23.896h-1.582l-5.253 15.735h3.22l.838-2.727h3.885l.838 2.727h3.284zm-1.961 10.325l1.138-4.251 1.117 4.251zM148.688 23.896h-1.581l-5.252 15.735h3.22l.838-2.727h3.886l.837 2.727h3.284zm-1.959 10.325l1.138-4.251 1.115 4.251zM105.616 39.628l5.123-15.735h-3.476l-2.485 9.209-2.483-9.209h-3.519l5.1 15.735zM132.31 39.628V23.896h-3.22v7.878l-6.236-7.878h-1.17v15.732h3.2v-8.072l6.3 8.072z",
    fill: "#002956"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6dcff6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.751 11.325l.033.065a5.154 5.154 0 01-1.266 3.693 4.685 4.685 0 01-3.546 1.308 4.741 4.741 0 01-3.733-1.576 6.407 6.407 0 01-1.4-4.4V5.994a6.5 6.5 0 011.38-4.41 4.639 4.639 0 013.683-1.586 4.8 4.8 0 013.59 1.28 5.24 5.24 0 011.288 3.742l-.033.066h-2.1a4.268 4.268 0 00-.688-2.577 2.473 2.473 0 00-2.063-.826 2.416 2.416 0 00-2.117 1.107 5.584 5.584 0 00-.753 3.156v4.461a5.558 5.558 0 00.769 3.19 2.485 2.485 0 002.166 1.107 2.415 2.415 0 002.013-.8 4.242 4.242 0 00.66-2.577zM214.05 9.498a5.968 5.968 0 011.228-3.873 4.486 4.486 0 016.728-.006 5.949 5.949 0 011.233 3.879v1.51a5.937 5.937 0 01-1.228 3.879 4.519 4.519 0 01-6.733 0 5.938 5.938 0 01-1.228-3.879zm2.215 1.5a5.369 5.369 0 00.589 2.666 2.053 2.053 0 003.574 0 5.331 5.331 0 00.595-2.666V9.485a5.312 5.312 0 00-.595-2.649 2.051 2.051 0 00-3.574-.005 5.341 5.341 0 00-.589 2.655zM230.005 6.193l-1.036-.055a1.622 1.622 0 00-1.141.416 2.636 2.636 0 00-.693 1.171v8.436h-2.215V4.322h2.016l.164 1.783a3.762 3.762 0 01.971-1.471 2.029 2.029 0 011.386-.531 2.724 2.724 0 01.447.038 1.708 1.708 0 01.36.093zM240.111 11.226a6.248 6.248 0 01-1.026 3.753 3.324 3.324 0 01-2.848 1.412 3.255 3.255 0 01-1.517-.339 3.166 3.166 0 01-1.124-1v5.662h-2.215V4.322h1.975l.142 1.357a3.47 3.47 0 011.146-1.166 2.971 2.971 0 011.572-.41 3.253 3.253 0 012.87 1.554 7.36 7.36 0 011.026 4.114zm-2.215-1.455a6.133 6.133 0 00-.573-2.84 1.831 1.831 0 00-1.708-1.1 1.871 1.871 0 00-1.211.4 2.851 2.851 0 00-.807 1.105v5.985a2.406 2.406 0 00.8 1.023 2.08 2.08 0 001.233.356 1.851 1.851 0 001.708-.958 4.951 4.951 0 00.562-2.522zM241.356 9.498a5.968 5.968 0 011.228-3.873 4.486 4.486 0 016.728-.006 5.949 5.949 0 011.233 3.879v1.51a5.937 5.937 0 01-1.228 3.879 4.519 4.519 0 01-6.733 0 5.937 5.937 0 01-1.228-3.879zm2.215 1.5a5.374 5.374 0 00.589 2.666 2.053 2.053 0 003.574 0 5.33 5.33 0 00.595-2.666V9.485a5.311 5.311 0 00-.595-2.649 2.051 2.051 0 00-3.574-.005 5.346 5.346 0 00-.589 2.655zM257.311 6.193l-1.037-.055a1.621 1.621 0 00-1.14.416 2.635 2.635 0 00-.694 1.171v8.436h-2.215V4.322h2.024l.164 1.783a3.756 3.756 0 01.971-1.471 2.028 2.028 0 011.386-.531 2.727 2.727 0 01.447.038 1.709 1.709 0 01.36.093zM264.274 16.161q-.12-.4-.2-.794a5.584 5.584 0 01-.1-.782 4.225 4.225 0 01-1.233 1.3 2.873 2.873 0 01-1.648.5 2.975 2.975 0 01-2.341-.947 3.659 3.659 0 01-.846-2.533 3.3 3.3 0 011.151-2.664 4.885 4.885 0 013.236-.968h1.648V8.066a2.629 2.629 0 00-.48-1.68 1.814 1.814 0 00-2.646-.06 1.966 1.966 0 00-.486 1.359l-2.106-.011-.032-.066a3.08 3.08 0 011.091-2.441 4.158 4.158 0 012.957-1.07 3.941 3.941 0 012.833 1.034 3.88 3.88 0 011.086 2.949v5.493a10.489 10.489 0 00.082 1.329 7.664 7.664 0 00.267 1.253zm-2.674-1.455a2.355 2.355 0 001.413-.462 2.724 2.724 0 00.933-1.155v-2.431h-1.68a1.965 1.965 0 00-1.577.655 2.37 2.37 0 00-.562 1.6 2.064 2.064 0 00.382 1.3 1.3 1.3 0 001.094.493zM271.085 1.378v2.943h1.844v1.587h-1.844v7.047a2.356 2.356 0 00.273 1.307.831.831 0 00.71.389 3.412 3.412 0 00.485-.033q.224-.033.53-.1l.229 1.532a4.51 4.51 0 01-.835.246 4.846 4.846 0 01-.955.093 2.4 2.4 0 01-1.948-.826 4.02 4.02 0 01-.693-2.61V5.906h-1.538V4.319h1.538V1.376zM278.932 16.391a4.234 4.234 0 01-3.372-1.466 5.539 5.539 0 01-1.265-3.753V9.443a5.842 5.842 0 011.238-3.83 3.9 3.9 0 013.149-1.51 3.7 3.7 0 013.088 1.373 5.81 5.81 0 011.081 3.693v1.532H276.5v.47a4.456 4.456 0 00.671 2.533 2.16 2.16 0 001.9 1 3.86 3.86 0 001.571-.29 4.414 4.414 0 001.244-.848l.7 1.379a4.112 4.112 0 01-1.495 1.039 5.413 5.413 0 01-2.159.407zm-.25-10.6a1.745 1.745 0 00-1.539.941 4.932 4.932 0 00-.644 2.385h4.158v-.452a3.859 3.859 0 00-.5-2.071 1.631 1.631 0 00-1.475-.806zM210.743 35.621a2.7 2.7 0 00-.633-1.849 5.193 5.193 0 00-2.215-1.27 8.951 8.951 0 01-3.481-1.8 3.789 3.789 0 01-1.212-2.934 3.959 3.959 0 011.348-3.088 5 5 0 013.465-1.208 4.713 4.713 0 013.552 1.4 4.515 4.515 0 011.3 3.365l-.021.066h-2.126a3.467 3.467 0 00-.715-2.268 2.8 2.8 0 00-3.918-.145 2.627 2.627 0 00-.671 1.855 2.285 2.285 0 00.72 1.713 6.514 6.514 0 002.379 1.264 7.726 7.726 0 013.306 1.851 4.18 4.18 0 011.136 3.035 3.888 3.888 0 01-1.342 3.111 5.229 5.229 0 01-3.525 1.15 5.789 5.789 0 01-3.716-1.264 4.152 4.152 0 01-1.533-3.561l.021-.066h2.128a3.131 3.131 0 00.856 2.421 3.191 3.191 0 002.243.785 2.654 2.654 0 001.948-.695 2.507 2.507 0 00.706-1.868zM214.181 32.974a5.968 5.968 0 011.228-3.873 4.486 4.486 0 016.728-.006 5.949 5.949 0 011.233 3.879v1.51a5.937 5.937 0 01-1.228 3.879 4.519 4.519 0 01-6.733 0 5.938 5.938 0 01-1.228-3.879zm2.215 1.5a5.37 5.37 0 00.589 2.666 2.053 2.053 0 003.574 0 5.332 5.332 0 00.595-2.666v-1.513a5.313 5.313 0 00-.595-2.649 2.051 2.051 0 00-3.574-.005 5.342 5.342 0 00-.589 2.655zM227.408 39.637h-2.215v-17.07h2.215zM235.878 38.051a3.552 3.552 0 01-1.2 1.346 3.039 3.039 0 01-1.681.471 2.909 2.909 0 01-2.5-1.236 6.6 6.6 0 01-.895-3.841v-6.995h2.2v7.014a5.58 5.58 0 00.431 2.577 1.4 1.4 0 001.293.761 2.343 2.343 0 001.37-.383 2.631 2.631 0 00.878-1.094v-8.875h2.215v11.839h-1.975zM242.883 24.854v2.943h1.844v1.587h-1.844v7.047a2.35 2.35 0 00.273 1.307.831.831 0 00.709.389 3.427 3.427 0 00.486-.033q.223-.033.529-.1l.229 1.532a4.494 4.494 0 01-.835.246 4.846 4.846 0 01-.955.093 2.4 2.4 0 01-1.948-.826 4.026 4.026 0 01-.693-2.61v-7.047h-1.539v-1.587h1.539v-2.943zM248.82 24.69h-2.215v-2.123h2.215zm0 14.947h-2.215V27.799h2.215zM250.622 32.974a5.967 5.967 0 011.228-3.873 4.485 4.485 0 016.727-.006 5.948 5.948 0 011.233 3.879v1.51a5.937 5.937 0 01-1.228 3.879 4.519 4.519 0 01-6.733 0 5.937 5.937 0 01-1.228-3.879zm2.215 1.5a5.367 5.367 0 00.589 2.666 2.053 2.053 0 003.574 0 5.33 5.33 0 00.595-2.666v-1.513a5.312 5.312 0 00-.595-2.649 2.05 2.05 0 00-3.574-.005 5.34 5.34 0 00-.589 2.655zM263.496 27.798l.12 1.751a3.971 3.971 0 011.244-1.45 2.928 2.928 0 011.7-.52 2.841 2.841 0 012.412 1.149 5.956 5.956 0 01.862 3.567v7.342h-2.216v-7.32a4.282 4.282 0 00-.469-2.33 1.61 1.61 0 00-1.419-.679 1.862 1.862 0 00-1.2.421 3.05 3.05 0 00-.851 1.144v8.764h-2.216V27.798zM277.425 36.672a1.629 1.629 0 00-.453-1.166 5.76 5.76 0 00-1.708-1.045 8.762 8.762 0 01-2.7-1.515 2.7 2.7 0 01-.879-2.085 3 3 0 011.075-2.325 4.084 4.084 0 012.821-.958 4.024 4.024 0 012.9 1.034 3.284 3.284 0 011.037 2.577l-.022.066h-2.128a2.284 2.284 0 00-.475-1.45 1.576 1.576 0 00-1.315-.607 1.733 1.733 0 00-1.293.471 1.522 1.522 0 00-.464 1.105 1.441 1.441 0 00.4 1.072 7.151 7.151 0 001.719 1.028 7.954 7.954 0 012.755 1.516 2.85 2.85 0 01.9 2.172 2.948 2.948 0 01-1.113 2.385 4.444 4.444 0 01-2.924.919 4.185 4.185 0 01-3.077-1.111 3.352 3.352 0 01-1.069-2.6l.022-.065h2.062a2.2 2.2 0 00.633 1.658 2.159 2.159 0 001.462.509 1.926 1.926 0 001.348-.444 1.478 1.478 0 00.486-1.141z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6dcff6",
    d: "M189.342.332v40"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 180 39.902",
    id: "logoFooterPrimaryWhite",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.224 39.652L47.36.295H33.51V24.57c0 8.453-3.85 13.784-10.685 15.086h11.399zM19.637 30.571c2.866 0 4.318-2 4.318-5.939V3.401L33.116.295H15.153v24.341c0 3.941 1.508 5.939 4.484 5.939M54.217 24.63l-2.685-9.271-3.29 11.286zM5.598 24.57V.29h-5.6v39.37h16c-6.653-1.3-10.4-6.632-10.4-15.086M58.568 39.652l-2.066-7.132-11.059 3.73-.991 3.4v.008h14.121zM68.964 39.653V.296H55.88zM81.075 20.25c-3.943 0-6.465-2.173-6.465-6.732V.295h4.076v13.249c0 1.9.833 3.031 2.523 3.031 1.662 0 2.44-1.127 2.44-3.031V.295h4.076v13.223c0 4.612-2.655 6.732-6.65 6.732M102.629 19.955l-7.9-10.084v10.084h-4l.027-19.66h1.472l7.755 9.843V.295h4.023v19.66zM107.389.295h4.075v19.66h-4.075zM118.902 4.05v4.641h5.15v3.619h-5.15v7.645h-4.078V.295h10.112v3.754zM133.835 20.25c-4.64 0-7.538-4.024-7.538-10.112S129.275 0 134.023 0c4.64 0 7.538 3.97 7.538 10.084 0 6.089-3 10.166-7.726 10.166m.081-16.656c-2.119 0-3.352 2.44-3.352 6.517 0 4.05 1.233 6.571 3.352 6.571s3.378-2.521 3.378-6.571c0-4.077-1.26-6.517-3.378-6.517M171.065 19.955l-.215-9.655-3.726 6.49h-.645l-3.835-6.49-.162 9.655h-3.916l.629-19.66h1.488l6.2 10.218L172.925.295h1.415l.671 19.66zM153.335 11.988a6.183 6.183 0 002.815-5.471c0-3.46-2.279-6.384-7.509-6.384a34.441 34.441 0 00-4.505.3v19.526h4.076V3.919a6.242 6.242 0 011.02-.079c1.8 0 2.762 1.1 2.762 2.922 0 2.035-1.622 3.036-3.382 3.092l3.7 10.1h4.454zM178.125.28a1.874 1.874 0 11-1.874 1.875A1.876 1.876 0 01178.125.28m1.414 1.875a1.415 1.415 0 10-1.414 1.47 1.44 1.44 0 001.414-1.47m-1.529.167h-.319v.9h-.373v-2.14h.835c.529 0 .8.181.8.616a.581.581 0 01-.55.605l.586.919h-.44zm.066-.314c.266 0 .5-.025.5-.323 0-.246-.263-.288-.475-.288h-.414v.611zM91.184 39.794a26.359 26.359 0 01-3.459-.236V24.025a28.44 28.44 0 013.394-.237c5.135 0 7.735 3.03 7.735 7.886 0 4.941-2.534 8.121-7.67 8.121m.622-13.042c-.321 0-.515.023-.816.044v9.99a5.588 5.588 0 00.923.066c2.321 0 3.525-2.02 3.525-5.157 0-3.072-1.332-4.942-3.633-4.942M140.615 26.945v12.721h-3.265V26.945h-3.288v-3.029h9.831v3.028zM164.694 30.619v7.993a7.838 7.838 0 01-4.448 1.289c-3.7 0-6.489-2.944-6.489-8.058 0-4.855 2.75-8.165 6.661-8.165a7.041 7.041 0 014.017 1.268l-1.289 2.687a4.752 4.752 0 00-2.621-.9c-2.149 0-3.352 2-3.352 5.091 0 3.4 1.4 5.222 3.245 5.222a2.75 2.75 0 001.246-.215v-3.352h-2v-2.858zM166.845 39.666v-15.75h8.164v3.007h-4.9v3.245h4.2v2.879h-4.2v3.61h4.9v3.008zM81.394 23.916h-1.582l-5.257 15.75h3.223l.837-2.73h3.891l.837 2.73h3.288zm-1.962 10.335l1.139-4.255 1.118 4.255zM115.626 23.916h-1.582l-5.257 15.75h3.221l.839-2.73h3.888l.838 2.73h3.286zm-1.962 10.335l1.139-4.255 1.118 4.255zM148.817 23.916h-1.582l-5.257 15.75h3.223l.838-2.73h3.884l.838 2.73h3.286zm-1.961 10.335l1.139-4.255 1.116 4.255zM105.707 39.666l5.128-15.749h-3.479l-2.487 9.217-2.486-9.217H98.86l5.107 15.749zM132.423 39.666v-15.75H129.2v7.885l-6.241-7.885h-1.17v15.75h3.2v-8.08l6.307 8.08z"
  })))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 200 19.671",
    id: "logoMobile",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.889 16.602c-2.669 0-4.375-1.453-4.375-4.5V3.259h2.759v8.861c0 1.274.564 2.027 1.707 2.027 1.125 0 1.652-.754 1.652-2.027V3.259h2.759v8.843c0 3.083-1.8 4.5-4.5 4.5M57.475 16.403l-5.348-6.742v6.742h-2.7l.018-13.146h1l5.248 6.582V3.257h2.723v13.146zM60.7 3.257h2.758v13.146H60.7zM68.492 5.768v3.1h3.485v2.421h-3.485V16.4h-2.76V3.257h6.844v2.511zM78.598 16.602c-3.14 0-5.1-2.692-5.1-6.763s2.015-6.78 5.228-6.78c3.14 0 5.1 2.654 5.1 6.744 0 4.071-2.034 6.8-5.23 6.8m.055-11.139c-1.434 0-2.268 1.632-2.268 4.359 0 2.708.834 4.395 2.268 4.395s2.286-1.687 2.286-4.395c0-2.726-.852-4.359-2.286-4.359M103.796 16.403l-.145-6.456-2.521 4.34h-.437l-2.6-4.34-.109 6.456h-2.65l.425-13.146h1.007l4.2 6.833 4.089-6.833h.956l.455 13.146zM91.792 11.077a4.121 4.121 0 001.906-3.658c0-2.315-1.543-4.269-5.083-4.269a23.378 23.378 0 00-3.049.2v13.056h2.758V5.68a4.148 4.148 0 01.691-.054 1.739 1.739 0 011.869 1.955 2.114 2.114 0 01-2.288 2.067l2.506 6.757h3.014zM124.336 16.527a22.5 22.5 0 01-2.927-.2V3.343a24.68 24.68 0 012.874-.2c4.345 0 6.546 2.534 6.546 6.593 0 4.132-2.147 6.791-6.493 6.791m.528-10.9c-.272 0-.436.018-.69.036v8.352a4.791 4.791 0 00.782.055c1.964 0 2.981-1.689 2.981-4.312 0-2.568-1.127-4.131-3.072-4.131M166.166 5.784v10.635h-2.762V5.784h-2.782V3.257h8.319v2.532zM186.542 8.858v6.682a6.683 6.683 0 01-3.764 1.078c-3.128 0-5.491-2.462-5.491-6.737 0-4.06 2.327-6.827 5.636-6.827a6.008 6.008 0 013.4 1.06l-1.09 2.245a4.053 4.053 0 00-2.218-.754c-1.819 0-2.837 1.67-2.837 4.257 0 2.838 1.182 4.365 2.745 4.365a2.361 2.361 0 001.055-.179v-2.8h-1.7V8.859zM116.053 3.252h-1.34l-4.448 13.167h2.727l.709-2.281h3.291l.709 2.281h2.781zm-1.66 8.641l.963-3.558.945 3.558zM145.021 3.252h-1.34l-4.449 13.167h2.728l.71-2.281h3.29l.71 2.281h2.78zm-1.66 8.641l.963-3.558.946 3.558zM173.107 3.252h-1.34l-4.449 13.167h2.728l.709-2.281h3.291l.708 2.281h2.784zm-1.661 8.641l.963-3.558.946 3.558zM136.628 16.419l4.339-13.162h-2.946l-2.1 7.706-2.1-7.706h-2.98l4.322 13.167zM159.234 16.419V3.257h-2.724v6.592l-5.283-6.592h-.992v13.167h2.707V9.669l5.338 6.755zM198.421 3.252a1.56 1.56 0 11-1.578 1.56 1.57 1.57 0 011.578-1.56m1.191 1.56a1.192 1.192 0 10-1.191 1.223 1.206 1.206 0 001.191-1.223m-1.288.139h-.268v.751h-.315v-1.78h.7c.447 0 .676.151.676.512a.486.486 0 01-.464.5l.494.765h-.367zm.056-.261c.224 0 .424-.021.424-.269 0-.2-.222-.24-.4-.24h-.349v.509zM17.312 19.668L23.955 0h-7.006v12.133c0 4.224-1.947 6.888-5.4 7.538h5.766zM9.931 15.131c1.449 0 2.184-1 2.184-2.968V1.553L16.748 0H7.663v12.164c0 1.969.763 2.968 2.268 2.968M27.42 12.16l-1.357-4.632-1.664 5.639zM2.831 12.132V0H0v19.671h8.091c-3.365-.65-5.26-3.314-5.26-7.538M29.62 19.668l-1.045-3.565-5.593 1.864-.5 1.7h7.141zM34.878 19.667V0H28.26zM188.36 16.422V3.25h6.911v2.511h-4.146v2.714h3.557v2.408h-3.557v3.019h4.146v2.516z"
  })))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 300 29.507",
    id: "logoTablet",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002956"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.334 24.904c-4 0-6.563-2.18-6.563-6.753V4.886h4.138v13.291c0 1.911.845 3.041 2.56 3.041 1.687 0 2.479-1.13 2.479-3.041V4.886h4.138v13.265c0 4.625-2.7 6.753-6.753 6.753M86.217 24.606l-8.022-10.114v10.114h-4.058l.027-19.72h1.494l7.872 9.873V4.886h4.084v19.72zM91.05 4.886h4.137v19.72H91.05zM102.737 8.653v4.654h5.228v3.631h-5.228v7.667h-4.14V4.886h10.266v3.767zM117.897 24.904c-4.71 0-7.651-4.038-7.651-10.144s3.023-10.17 7.842-10.17c4.71 0 7.654 3.982 7.654 10.115 0 6.107-3.052 10.2-7.845 10.2m.082-16.709c-2.151 0-3.4 2.449-3.4 6.538 0 4.061 1.251 6.592 3.4 6.592s3.429-2.531 3.429-6.592c0-4.09-1.278-6.538-3.429-6.538M155.69 24.606l-.218-9.684-3.781 6.51h-.655l-3.894-6.51-.164 9.684h-3.975l.638-19.72h1.51l6.293 10.249 6.134-10.249h1.434l.683 19.72zM137.695 16.615a6.181 6.181 0 002.859-5.487c0-3.472-2.315-6.4-7.625-6.4a35.068 35.068 0 00-4.573.3v19.578h4.137V8.518a6.222 6.222 0 011.037-.081 2.609 2.609 0 012.8 2.933c0 2.041-1.646 3.046-3.433 3.1l3.759 10.135h4.521zM186.505 24.79a33.745 33.745 0 01-4.391-.3V5.014a37.013 37.013 0 014.31-.3c6.518 0 9.819 3.8 9.819 9.89 0 6.2-3.22 10.186-9.739 10.186m.791-16.356c-.409 0-.654.028-1.035.054v12.526a7.19 7.19 0 001.173.082c2.946 0 4.471-2.533 4.471-6.468 0-3.853-1.69-6.2-4.609-6.2M249.25 8.676v15.953h-4.147V8.676h-4.174V4.883h12.479v3.8zM279.812 13.285v10.024a10.023 10.023 0 01-5.646 1.617c-4.692 0-8.236-3.693-8.236-10.105 0-6.091 3.491-10.241 8.454-10.241a9.011 9.011 0 015.1 1.59l-1.636 3.368a6.081 6.081 0 00-3.327-1.13c-2.728 0-4.255 2.506-4.255 6.385 0 4.257 1.773 6.548 4.118 6.548a3.541 3.541 0 001.583-.269v-4.2h-2.543v-3.583zM174.079 4.878h-2.01l-6.672 19.751h4.091l1.063-3.422h4.937l1.064 3.422h4.172zm-2.49 12.961l1.444-5.336 1.418 5.336zM217.531 4.878h-2.01l-6.674 19.751h4.092l1.065-3.422h4.935l1.065 3.422h4.17zm-2.49 12.961l1.445-5.336 1.419 5.336zM259.661 4.878h-2.011l-6.673 19.751h4.092l1.064-3.422h4.936l1.062 3.422h4.175zm-2.492 12.961l1.445-5.336 1.419 5.336zM204.945 24.629l6.506-19.746h-4.418l-3.154 11.559-3.158-11.559h-4.471l6.483 19.751zM238.85 24.629V4.883h-4.09v9.889l-7.92-9.889h-1.488v19.751h4.061V14.497l8.006 10.132zM297.632 4.878a2.34 2.34 0 11-2.367 2.341 2.354 2.354 0 012.367-2.341m1.786 2.341a1.787 1.787 0 10-1.786 1.834 1.809 1.809 0 001.786-1.834m-1.932.208h-.4v1.127h-.473V5.883h1.053c.67 0 1.014.226 1.014.768a.729.729 0 01-.7.755l.742 1.148h-.55zm.084-.392c.336 0 .637-.031.637-.4 0-.307-.333-.359-.6-.359h-.523v.763zM25.968 29.501l9.964-29.5h-10.51v18.2c0 6.337-2.921 10.332-8.106 11.307h8.649zM14.901 22.697c2.174 0 3.276-1.5 3.276-4.451V2.329L25.126 0H11.495v18.245c0 2.953 1.145 4.451 3.4 4.451M41.13 18.24l-2.036-6.948-2.5 8.458zM4.246 18.199v-18.2H0v29.506h12.136c-5.047-.975-7.89-4.97-7.89-11.307M44.431 29.501l-1.567-5.347-8.389 2.8-.752 2.551v.005h10.711zM52.317 29.501V.001h-9.926zM282.54 24.633V4.875h10.367v3.772h-6.217v4.071h5.336v3.613h-5.336v4.529h6.22v3.773z"
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 18.5",
    id: "menuMobileDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-menu",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2648",
    d: "M0 17.25h24"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2646",
    d: "M0 9.25h19.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2647",
    d: "M0 1.25h24"
  })))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 14",
    id: "menuMobileLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7h13.7M0 1h18M0 13h18",
    className: "cecls-1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 2",
    id: "minus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M.995 1h16"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 45 45",
    id: "navLeft",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248 -1331.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "rgba(255,255,255,0.75)",
    rx: 22.5,
    transform: "translate(248 1331.785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.819 1354.281l8.937-8.93a1.688 1.688 0 00-2.391-2.384l-10.125 10.114a1.685 1.685 0 00-.049 2.327l10.167 10.193a1.688 1.688 0 002.391-2.384z"
  })))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 45 45",
    id: "navRight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1570 -1331.785)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "rgba(255,255,255,0.75)",
    rx: 22.5,
    transform: "translate(1570 1331.785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.181 1354.28l-8.937-8.93a1.681 1.681 0 010-2.384 1.7 1.7 0 012.391 0l10.125 10.114a1.685 1.685 0 01.049 2.327l-10.167 10.193a1.688 1.688 0 01-2.391-2.384z"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 74",
    id: "new-badge",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Bubble - NEW",
    transform: "translate(0 .269)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1240",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(0 -.269)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(11 46.731)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "Lato-Italic, Lato",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "new"))))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.454 22.838",
    id: "paypal-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002c8a",
    d: "M17.297 7L5.015 20.4h-4.5a.53.53 0 01-.5-.626l3-19.021a.877.877 0 01.876-.751h7.633C16.78.19 18.219 2.88 17.28 7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009be1",
    d: "M17.498 5.756c1.877 1 2.315 2.878 1.689 5.381-.813 3.692-3.254 5.256-6.82 5.318l-1 .063a.682.682 0 00-.688.626l-.813 4.943a.877.877 0 01-.876.751H5.236a.53.53 0 01-.5-.626l1.377-8.947c.059-.309 11.385-7.509 11.385-7.509z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001f6b",
    d: "M6.035 13.703l1.251-7.946a.876.876 0 01.813-.688h6.007a7.347 7.347 0 013.379.688c-.313 2.753-1.627 7.2-8.009 7.321H6.723a.729.729 0 00-.688.625z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 18",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1v16M1 9h16",
    className: "ckcls-1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 18",
    id: "plusWhite",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1v16M1 9h16",
    className: "clcls-1",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 19.997",
    id: "radio",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.315 19.497c-2.78-.002-5.211-.963-7.029-2.78A9.445 9.445 0 01.5 9.998a9.45 9.45 0 012.68-6.61A9.465 9.465 0 019.655.5h.028c2.606 0 5.044.943 6.864 2.653A9.321 9.321 0 0119.5 9.687c0 2.723-.924 5.116-2.674 6.921a9.462 9.462 0 01-6.511 2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M9.662 1.001a8.968 8.968 0 00-6.123 2.736A8.956 8.956 0 001 9.999c0 2.403.937 4.663 2.64 6.364 1.72 1.72 4.025 2.63 6.667 2.634a8.96 8.96 0 006.16-2.737c1.656-1.708 2.532-3.978 2.533-6.565a8.82 8.82 0 00-2.795-6.176c-1.727-1.624-4.044-2.518-6.522-2.518h-.021M9.682 0v.001c2.845 0 5.369 1.06 7.208 2.79A9.84 9.84 0 0120 9.679c.003 3.016-1.067 5.474-2.815 7.278a9.986 9.986 0 01-6.862 3.04c-3.073 0-5.578-1.115-7.39-2.927A9.967 9.967 0 010 9.999a9.968 9.968 0 012.82-6.958A9.996 9.996 0 019.684 0z"
  })))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 19.997",
    id: "radioSelected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.315 19.497c-2.78-.002-5.211-.963-7.029-2.78A9.445 9.445 0 01.5 9.998a9.45 9.45 0 012.68-6.61A9.465 9.465 0 019.655.5h.028c2.606 0 5.044.943 6.864 2.653A9.321 9.321 0 0119.5 9.687c0 2.723-.924 5.116-2.674 6.921a9.462 9.462 0 01-6.511 2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M9.662 1.001a8.968 8.968 0 00-6.123 2.736A8.956 8.956 0 001 9.999c0 2.403.937 4.663 2.64 6.364 1.72 1.72 4.025 2.63 6.667 2.634a8.96 8.96 0 006.16-2.737c1.656-1.708 2.532-3.978 2.533-6.565a8.82 8.82 0 00-2.795-6.176c-1.727-1.624-4.044-2.518-6.522-2.518h-.021M9.682 0v.001c2.845 0 5.369 1.06 7.208 2.79A9.84 9.84 0 0120 9.679c.003 3.016-1.067 5.474-2.815 7.278a9.986 9.986 0 01-6.862 3.04c-3.073 0-5.578-1.115-7.39-2.927A9.967 9.967 0 010 9.999a9.968 9.968 0 012.82-6.958A9.996 9.996 0 019.684 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 9.999a4 4 0 114 4 4 4 0 01-4-4z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14.857 14.17",
    id: "rating",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M10.152 8.679l.643 3.759-3.366-1.777-3.375 1.777.651-3.759-2.732-2.65 3.768-.554 1.688-3.411 1.687 3.41 3.768.554zm4.705-3.188c0-.268-.286-.375-.5-.411l-4.482-.651L7.866.366C7.786.196 7.634 0 7.428 0s-.357.2-.438.366L4.982 4.429.5 5.081c-.223.036-.5.143-.5.411a.7.7 0 00.223.429l3.25 3.161-.768 4.463a1.21 1.21 0 00-.018.179c0 .232.116.446.375.446a.754.754 0 00.358-.107l4.009-2.107 4.009 2.107a.725.725 0 00.357.107c.259 0 .366-.205.366-.446a1.2 1.2 0 00-.009-.179l-.768-4.464 3.241-3.161a.665.665 0 00.232-.429z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14.857 14.17",
    id: "ratingFull",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M14.857 5.491c0-.268-.286-.375-.5-.411l-4.482-.651L7.866.366C7.786.196 7.634 0 7.428 0s-.357.2-.438.366L4.982 4.429.5 5.081c-.223.036-.5.143-.5.411a.7.7 0 00.223.429l3.25 3.161-.768 4.463a1.21 1.21 0 00-.018.179c0 .232.116.446.375.446a.754.754 0 00.358-.107l4.009-2.107 4.009 2.107a.725.725 0 00.357.107c.259 0 .366-.214.366-.446a1.2 1.2 0 00-.009-.179l-.768-4.464 3.241-3.161a.665.665 0 00.232-.429z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "ratingHalf",
    viewBox: "0 0 14.857 14.299",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cqclip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cqPath_3592",
    d: "M14.857-7.938c0-.268-.286-.375-.5-.411L9.875-9l-2.009-4.063c-.08-.17-.232-.366-.438-.366s-.357.2-.438.366L4.982-9 .5-8.348c-.223.036-.5.143-.5.411a.7.7 0 00.223.429l3.25 3.161L2.705.116a1.21 1.21 0 00-.018.179c0 .232.116.446.375.446A.754.754 0 003.42.634l4.009-2.107L11.438.634a.725.725 0 00.357.107c.259 0 .366-.214.366-.446a1.2 1.2 0 00-.009-.179l-.768-4.464 3.241-3.161a.665.665 0 00.232-.429z",
    className: "cqcls-1",
    transform: "translate(818 805.129)"
  })), /*#__PURE__*/React.createElement("style", null, ".cqcls-1{fill:#404040}")), /*#__PURE__*/React.createElement("g", {
    id: "cqMask_Group_214",
    clipPath: "url(#cqclip-path)",
    transform: "translate(-818 -791.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cqPath_3593",
    d: "M0 0h7.429v14.17H0z",
    className: "cqcls-1",
    transform: "translate(818 791.701)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cqPath_3591",
    d: "M10.152-4.75l.643 3.759-3.366-1.777L4.054-.991l.651-3.759L1.973-7.4l3.768-.554 1.688-3.411 1.687 3.41 3.768.554zm4.705-3.188c0-.268-.286-.375-.5-.411L9.875-9l-2.009-4.063c-.08-.17-.232-.366-.438-.366s-.357.2-.438.366L4.982-9 .5-8.348c-.223.036-.5.143-.5.411a.7.7 0 00.223.429l3.25 3.161L2.705.116a1.21 1.21 0 00-.018.179c0 .232.116.446.375.446A.754.754 0 003.42.634l4.009-2.107L11.438.634a.725.725 0 00.357.107c.259 0 .366-.205.366-.446a1.2 1.2 0 00-.009-.179l-.768-4.464 3.241-3.161a.665.665 0 00.232-.429z",
    className: "cqcls-1",
    transform: "translate(0 13.429)"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15.587 15.587",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 176",
    d: "M1 1.586h12v12H1z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-search",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2634",
    d: "M11.667 6.333A5.333 5.333 0 116.333 1a5.333 5.333 0 015.333 5.333z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2635",
    d: "M14.173 14.173L10.1 10.1"
  }))))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 21.047 23",
    id: "shopMultiple",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4768",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-tshirt",
    d: "M20.269 3.516L14.185.5a4.535 4.535 0 01-3.641 1.475A4.535 4.535 0 016.903.5L.819 3.516a.5.5 0 00-.225.672l.35.712c1.558 3.116 17.627 3.116 19.2-.025l.343-.684a.5.5 0 00-.218-.675z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-tshirt",
    d: "M20.269 6.516L14.185 3.5a4.535 4.535 0 01-3.641 1.475A4.535 4.535 0 016.903 3.5L.819 6.516a.5.5 0 00-.225.672l.35.712c1.558 3.116 17.627 3.116 19.2-.025l.343-.684a.5.5 0 00-.218-.675z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-tshirt",
    d: "M20.269 9.516L14.185 6.5a4.535 4.535 0 01-3.641 1.475A4.535 4.535 0 016.903 6.5L.819 9.516a.5.5 0 00-.225.672l1.788 3.578a.5.5 0 00.672.225l1.769-.866a.5.5 0 01.721.45V21.5a1 1 0 001 1h8a1 1 0 001-1v-7.928a.5.5 0 01.719-.45l1.769.866a.5.5 0 00.672-.225l1.791-3.575a.5.5 0 00-.226-.672z"
  })))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17.395 18.149",
    id: "shoppingBag",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3567"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.669 4.009h16.057l.674 10.814c0 1.838-1.2 3.327-2.676 3.327H2.676C1.2 18.15 0 16.66 0 14.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55 6.009L2 14.875c.019.78.449 1.275.676 1.275H14.72c.227 0 .657-.495.675-1.275l-.548-8.866H2.549m-1.88-2h16.057l.669 10.814c0 1.837-1.198 3.327-2.676 3.327H2.676C1.198 18.15 0 16.66 0 14.823L.669 4.009z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3569",
    d: "M5.217 7.003V4.814a3.589 3.589 0 013.31-3.811 3.589 3.589 0 013.311 3.811v2.189",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "11 12.43 17.4 18.15",
    id: "shoppingBagV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "bag icon",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 3567"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.669 16.434h16.057l.674 10.814c0 1.838-1.2 3.327-2.676 3.327H13.676c-1.476 0-2.676-1.49-2.676-3.327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55 18.434L13 27.3c.019.78.449 1.275.676 1.275H25.72c.227 0 .657-.495.675-1.275l-.548-8.866H13.549m-1.88-2h16.057l.669 10.814c0 1.837-1.198 3.327-2.676 3.327H13.676c-1.478 0-2.676-1.49-2.676-3.327l.669-10.814z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3569",
    d: "M16.217 19.428v-2.189a3.589 3.589 0 013.31-3.811 3.589 3.589 0 013.311 3.811v2.189",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 74",
    id: "slightly-irregular-badge",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Bubble - Slightly Irregular",
    transform: "translate(-.394 -.32)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1240",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(.394 .32)",
    fill: "#ffd83c"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "slightly irregular",
    transform: "translate(37.394 33.315)",
    fontSize: 17,
    fontFamily: "Lato-Italic, Lato",
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.833,
    y: 0
  }, "slightly"), /*#__PURE__*/React.createElement("tspan", {
    x: -29.457,
    y: 17
  }, "irregular"))))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 18.766",
    id: "snapchat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.207 17.708a3.812 3.812 0 00-3.478-.738c-.264.053-.738.211-.791-.264-.105-.369-.105-.949-.369-1-1.634-.211-2.213-.527-2.477-.843-.105-.105-.158-.369.053-.422 2.793-.527 4.111-3.215 4.374-3.742.316-.791-.211-1.265-1.212-1.581-.474-.158-1.265-.369-1.265-.9 0-.264.264-.422.527-.527a.873.873 0 01.632 0c.632.264 1.212.369 1.528.105 0-1.423-.369-3.215.211-4.69a5.671 5.671 0 0110.119 0c.58 1.476.211 3.267.211 4.69.316.264.9.158 1.528-.105a.873.873 0 01.632 0c.264.105.527.264.527.527 0 .527-.791.738-1.265.9-1 .316-1.528.791-1.212 1.581.264.527 1.581 3.215 4.374 3.742.211.053.158.316.053.422-.264.316-.843.632-2.477.843-.264.053-.264.632-.369 1-.053.474-.527.316-.791.264a3.812 3.812 0 00-3.478.738 4.321 4.321 0 01-2.793 1.054 4.088 4.088 0 01-2.792-1.054z"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10.407 20.065",
    id: "socialFacebookDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.764 20.065v-9.138h3.08l.46-3.577h-3.54V5.072c0-1.034.289-1.74 1.769-1.74h1.877V.142A25.472 25.472 0 007.658 0C4.933 0 3.064 1.665 3.064 4.715v2.628H0v3.578h3.07v9.144h3.694z"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10.407 20.065",
    id: "socialFacebookLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.764 20.065v-9.138h3.08l.46-3.577h-3.54V5.072c0-1.034.289-1.74 1.769-1.74h1.877V.142A25.472 25.472 0 007.658 0C4.933 0 3.064 1.665 3.064 4.715v2.628H0v3.578h3.07v9.144h3.694z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.785 19.784",
    id: "socialInstagramDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.941 0c1.22 0 1.773.01 2.3.028l.2.008c.165.006.336.014.531.023a7.251 7.251 0 012.4.46 5.051 5.051 0 012.893 2.893 7.249 7.249 0 01.46 2.4l.023.532.007.2c.02.592.028 1.22.03 2.79v1.119c0 1.57-.01 2.2-.03 2.79l-.007.2-.023.532a7.244 7.244 0 01-.46 2.4 5.059 5.059 0 01-2.893 2.893 7.256 7.256 0 01-2.4.46c-.195.01-.366.017-.531.023l-.2.008c-.592.02-1.22.027-2.79.028H9.332c-1.57 0-2.2-.008-2.79-.028l-.2-.008c-.166-.006-.337-.014-.532-.023a7.244 7.244 0 01-2.4-.46 5.044 5.044 0 01-2.893-2.893 7.249 7.249 0 01-.46-2.4l-.024-.532-.007-.2a68.454 68.454 0 01-.028-2.3v-2.1c0-1.22.01-1.774.028-2.3l.007-.2.024-.532a7.244 7.244 0 01.46-2.4A5.051 5.051 0 013.41.518a7.244 7.244 0 012.4-.46c.195-.01.366-.017.532-.023l.2-.008c.527-.018 1.08-.026 2.3-.028zm-.25 1.782h-1.6c-1.921 0-2.272.015-3.2.057a5.489 5.489 0 00-1.837.341 3.276 3.276 0 00-1.877 1.878 5.431 5.431 0 00-.34 1.836c-.043.928-.056 1.278-.058 3.2v1.6c0 1.922.015 2.272.057 3.2a5.483 5.483 0 00.34 1.836 3.274 3.274 0 001.878 1.878 5.47 5.47 0 001.837.34c.193.01.361.017.524.023l.194.007c.515.018 1.053.025 2.249.027h2.061c1.2 0 1.734-.009 2.25-.027l.193-.007.524-.022a5.478 5.478 0 001.837-.341 3.274 3.274 0 001.878-1.878 5.485 5.485 0 00.34-1.837c.01-.193.017-.36.023-.523l.007-.194c.018-.516.025-1.053.027-2.25v-2.06c0-1.2-.009-1.735-.027-2.25l-.007-.194c-.006-.162-.014-.33-.023-.524a5.483 5.483 0 00-.34-1.836 3.274 3.274 0 00-1.878-1.878 5.459 5.459 0 00-1.837-.34c-.927-.043-1.277-.056-3.2-.058zm-.8 3.03a5.08 5.08 0 11-5.08 5.08 5.079 5.079 0 015.08-5.08zm0 1.782a3.3 3.3 0 103.3 3.3 3.3 3.3 0 00-3.3-3.3zm5.281-3.17a1.187 1.187 0 11-1.187 1.187 1.188 1.188 0 011.187-1.187z"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.785 19.784",
    id: "socialInstagramLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.941 0c1.22 0 1.773.01 2.3.028l.2.008c.165.006.336.014.531.023a7.251 7.251 0 012.4.46 5.051 5.051 0 012.893 2.893 7.249 7.249 0 01.46 2.4l.023.532.007.2c.02.592.028 1.22.03 2.79v1.119c0 1.57-.01 2.2-.03 2.79l-.007.2-.023.532a7.244 7.244 0 01-.46 2.4 5.059 5.059 0 01-2.893 2.893 7.256 7.256 0 01-2.4.46c-.195.01-.366.017-.531.023l-.2.008c-.592.02-1.22.027-2.79.028H9.332c-1.57 0-2.2-.008-2.79-.028l-.2-.008c-.166-.006-.337-.014-.532-.023a7.244 7.244 0 01-2.4-.46 5.044 5.044 0 01-2.893-2.893 7.249 7.249 0 01-.46-2.4l-.024-.532-.007-.2a68.454 68.454 0 01-.028-2.3v-2.1c0-1.22.01-1.774.028-2.3l.007-.2.024-.532a7.244 7.244 0 01.46-2.4A5.051 5.051 0 013.41.518a7.244 7.244 0 012.4-.46c.195-.01.366-.017.532-.023l.2-.008c.527-.018 1.08-.026 2.3-.028zm-.25 1.782h-1.6c-1.921 0-2.272.015-3.2.057a5.489 5.489 0 00-1.837.341 3.276 3.276 0 00-1.877 1.878 5.431 5.431 0 00-.34 1.836c-.043.928-.056 1.278-.058 3.2v1.6c0 1.922.015 2.272.057 3.2a5.483 5.483 0 00.34 1.836 3.274 3.274 0 001.878 1.878 5.47 5.47 0 001.837.34c.193.01.361.017.524.023l.194.007c.515.018 1.053.025 2.249.027h2.061c1.2 0 1.734-.009 2.25-.027l.193-.007.524-.022a5.478 5.478 0 001.837-.341 3.274 3.274 0 001.878-1.878 5.485 5.485 0 00.34-1.837c.01-.193.017-.36.023-.523l.007-.194c.018-.516.025-1.053.027-2.25v-2.06c0-1.2-.009-1.735-.027-2.25l-.007-.194c-.006-.162-.014-.33-.023-.524a5.483 5.483 0 00-.34-1.836 3.274 3.274 0 00-1.878-1.878 5.459 5.459 0 00-1.837-.34c-.927-.043-1.277-.056-3.2-.058zm-.8 3.03a5.08 5.08 0 11-5.08 5.08 5.079 5.079 0 015.08-5.08zm0 1.782a3.3 3.3 0 103.3 3.3 3.3 3.3 0 00-3.3-3.3zm5.281-3.17a1.187 1.187 0 11-1.187 1.187 1.188 1.188 0 011.187-1.187z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "socialPinterestDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0a10 10 0 00-3.644 19.315 9.594 9.594 0 01.034-2.872c.182-.78 1.173-4.97 1.173-4.97a3.608 3.608 0 01-.3-1.485c0-1.39.807-2.428 1.81-2.428a1.256 1.256 0 011.266 1.408 20.181 20.181 0 01-.829 3.33 1.453 1.453 0 001.481 1.802c1.778 0 3.144-1.874 3.144-4.58a3.947 3.947 0 00-4.177-4.068 4.329 4.329 0 00-4.516 4.34 3.885 3.885 0 00.745 2.282.3.3 0 01.069.287c-.076.316-.245 1-.278 1.134-.044.183-.145.222-.334.134-1.25-.582-2.03-2.408-2.03-3.874 0-3.155 2.292-6.052 6.607-6.052a5.868 5.868 0 016.165 5.776c0 3.446-2.173 6.22-5.189 6.22a2.677 2.677 0 01-2.292-1.149l-.623 2.378a11.176 11.176 0 01-1.243 2.621A10 10 0 1010 0"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "socialPinterestLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 0a10 10 0 00-3.644 19.315 9.594 9.594 0 01.034-2.872c.182-.78 1.173-4.97 1.173-4.97a3.608 3.608 0 01-.3-1.485c0-1.39.807-2.428 1.81-2.428a1.256 1.256 0 011.266 1.408 20.181 20.181 0 01-.829 3.33 1.453 1.453 0 001.481 1.802c1.778 0 3.144-1.874 3.144-4.58a3.947 3.947 0 00-4.177-4.068 4.329 4.329 0 00-4.516 4.34 3.885 3.885 0 00.745 2.282.3.3 0 01.069.287c-.076.316-.245 1-.278 1.134-.044.183-.145.222-.334.134-1.25-.582-2.03-2.408-2.03-3.874 0-3.155 2.292-6.052 6.607-6.052a5.868 5.868 0 016.165 5.776c0 3.446-2.173 6.22-5.189 6.22a2.677 2.677 0 01-2.292-1.149l-.623 2.378a11.176 11.176 0 01-1.243 2.621A10 10 0 1010 0"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17.314 19.784",
    id: "socialTiktokLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.294 8.113a8.11 8.11 0 01-4.726-1.517v6.908a6.287 6.287 0 01-6.284 6.282A6.287 6.287 0 010 13.502a6.287 6.287 0 017.147-6.224v3.475a2.887 2.887 0 00-3.75 2.752 2.887 2.887 0 002.884 2.885 2.887 2.887 0 002.885-2.886V-.002h3.402v.039c0 .28.025.55.072.817a4.726 4.726 0 002.084 3.101c.742.49 1.63.776 2.584.776l.006.002v3.379h-.02z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20.583 16.908",
    id: "socialTwitterDark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.489 4.764q0-.277-.012-.552a8.649 8.649 0 002.106-2.21 8.33 8.33 0 01-2.425.672A4.277 4.277 0 0020.015.317a8.424 8.424 0 01-2.681 1.036A4.2 4.2 0 0014.251 0a4.247 4.247 0 00-4.223 4.268 4.34 4.34 0 00.109.974 11.946 11.946 0 01-8.7-4.46 4.3 4.3 0 001.307 5.7 4.151 4.151 0 01-1.913-.534v.055a4.258 4.258 0 003.387 4.184 4.174 4.174 0 01-1.907.073 4.235 4.235 0 003.945 2.965 8.414 8.414 0 01-5.245 1.827A8.39 8.39 0 010 14.99a11.86 11.86 0 006.473 1.918A12 12 0 0018.489 4.764z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20.583 16.908",
    id: "socialTwitterLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.489 4.764q0-.277-.012-.552a8.649 8.649 0 002.106-2.21 8.33 8.33 0 01-2.425.672A4.277 4.277 0 0020.015.317a8.424 8.424 0 01-2.681 1.036A4.2 4.2 0 0014.251 0a4.247 4.247 0 00-4.223 4.268 4.34 4.34 0 00.109.974 11.946 11.946 0 01-8.7-4.46 4.3 4.3 0 001.307 5.7 4.151 4.151 0 01-1.913-.534v.055a4.258 4.258 0 003.387 4.184 4.174 4.174 0 01-1.907.073 4.235 4.235 0 003.945 2.965 8.414 8.414 0 01-5.245 1.827A8.39 8.39 0 010 14.99a11.86 11.86 0 006.473 1.918A12 12 0 0018.489 4.764z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.302 17.607",
    id: "sustainable",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#44ae99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.655 17.607a.56.56 0 01-.408-.2c-.423-.452-.854-.909-1.276-1.357l-2.838-3a.4.4 0 01-.059-.472c.124-.223 3.061-5.484 6.184-6.375l.111-.016a.4.4 0 01.387.293.4.4 0 01-.277.5c-2.442.7-4.934 4.687-5.553 5.737 0 0 3.305 3.5 3.73 3.954l3.669-3.89c1.284-1.362 2.595-2.751 3.884-4.124a4.72 4.72 0 001.277-2.923 4.878 4.878 0 00-.058-1.129 4.371 4.371 0 00-4.16-3.791 8.918 8.918 0 00-1.248.061 4.665 4.665 0 00-2.614 1.438l-.12.128c-.1.1-.167.176-.231.251a.492.492 0 01-.8 0c-.06-.072-.126-.14-.2-.213s-.108-.113-.158-.169a4.4 4.4 0 00-3.4-1.486c-.125 0-.251 0-.38.013a4.4 4.4 0 00-3.962 2.8A4.54 4.54 0 00.818 5.02a4.247 4.247 0 00.06 1.206 4.915 4.915 0 001.177 2.386l1.408 1.5.78.824a.403.403 0 11-.587.553l-.832-.881a327.44 327.44 0 01-1.357-1.441A5.7 5.7 0 01.091 6.402a5.078 5.078 0 01-.074-1.465 5.319 5.319 0 01.4-1.624A5.154 5.154 0 015.064.034Q5.285.02 5.5.02a5.178 5.178 0 013.993 1.752l.153.163.156-.166A5.458 5.458 0 0112.871.083 9.5 9.5 0 0114.257.01a5.163 5.163 0 014.953 4.445 5.727 5.727 0 01.069 1.349 5.51 5.51 0 01-1.492 3.407c-1.39 1.482-2.806 2.981-4.186 4.444l-3.549 3.763a.555.555 0 01-.397.189z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.773 11.929q-.213 0-.432-.016a.403.403 0 01.029-.805c.155.01.278.015.4.015a3.994 3.994 0 002.722-1.019c1.869-1.652 2.454-4.92 2.62-6.265a15.2 15.2 0 01-3.173.956l-.478.094c-1.319.253-2.447.47-3.148 1.674a3.9 3.9 0 00-.07 3.671.4.4 0 01-.179.541.406.406 0 01-.181.043.4.4 0 01-.36-.222 4.707 4.707 0 01.094-4.439c.886-1.521 2.243-1.781 3.68-2.058l.481-.094a13.011 13.011 0 003.611-1.2.4.4 0 01.193-.049.4.4 0 01.4.423 16.312 16.312 0 01-.456 2.846 9.045 9.045 0 01-2.5 4.683 4.775 4.775 0 01-3.253 1.221z"
  })))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 18",
    id: "tooltip",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.925 7.985H7.31a.117.117 0 01-.116-.135l.038-.244a.116.116 0 01.1-.1l2.82-.3a.118.118 0 01.128.14l-1.049 5.272a.233.233 0 00.287.274 1.872 1.872 0 00.892-.769.117.117 0 01.18-.011l.178.189a.117.117 0 01.008.152c-1.164 1.526-3.741 2.415-3.324.228l.816-4.277a.353.353 0 00-.345-.419zM9.552 4.011a1.148 1.148 0 11-1.148 1.148 1.149 1.149 0 011.148-1.148z",
    className: "dhcls-2"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12.5 13.728",
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#757676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.625 3.103h11.25M5 6.228v3.75M7.5 6.228v3.75M10.625 3.103v8.75a1.25 1.25 0 01-1.25 1.25h-6.25a1.25 1.25 0 01-1.25-1.25v-8.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.822 3.103c0-2.643-1.54-2.6-2.615-2.6S3.65.453 3.65 3.103"
  })))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12.642 17.604",
    id: "trashHover",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M.767 5.238L11.634 2.33M6.393 10.103v3.75M8.893 10.103v3.75M12.018 6.978v8.75a1.25 1.25 0 01-1.25 1.25h-6.25a1.25 1.25 0 01-1.25-1.25v-8.75",
    className: "djcls-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M8.68 3.122c-.683-2.55-2.16-2.114-3.2-1.836s-2.483.62-1.8 3.173"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23.75 23.75",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 15.5v4.833a2.417 2.417 0 01-2.417 2.417H3.417A2.417 2.417 0 011 20.333V15.5M17.917 7.042L11.875 1 5.833 7.042M11.875 1v14.5"
  })))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23.75 23.75",
    id: "uploadLight",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#757676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 15.5v4.833a2.417 2.417 0 01-2.417 2.417H3.417A2.417 2.417 0 011 20.333V15.5M17.917 7.042L11.875 1 5.833 7.042M11.875 1v14.5"
  })))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26.11 23.029",
    id: "wishlist",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#acacac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.251 2.859a6.344 6.344 0 00-8.974 0l-1.222 1.223-1.223-1.223a6.345 6.345 0 10-8.973 8.974l1.218 1.223 8.974 8.974 8.974-8.974 1.223-1.223a6.344 6.344 0 000-8.974z"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24.11 21.029",
    id: "wishlistSelected",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M22.251 1.859a6.344 6.344 0 00-8.974 0l-1.222 1.223-1.223-1.223a6.345 6.345 0 10-8.973 8.974l1.218 1.223 8.974 8.974 8.974-8.974 1.223-1.223a6.344 6.344 0 000-8.974z"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 19.996 14.084",
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.985 14.084a45.643 45.643 0 01-7.79-.421 2.541 2.541 0 01-1.799-1.742 30.38 30.38 0 010-9.778A2.541 2.541 0 012.196.4a48.923 48.923 0 017.65-.4 52.95 52.95 0 017.972.4 2.541 2.541 0 011.8 1.742 31.609 31.609 0 010 9.778 2.541 2.541 0 01-1.8 1.742 46.5 46.5 0 01-7.833.422zm-2-10.031v5.957l5.225-2.978z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1col",
    width: 12,
    height: 15,
    x: 0
  })), _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "1col-view",
    viewBox: "0 0 12 15"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2col",
    width: 17,
    height: 10,
    x: 12
  })), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    id: "2col-view",
    viewBox: "12 0 17 10"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3col",
    width: 27.718,
    height: 19.579,
    x: 29
  })), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    id: "3col-view",
    viewBox: "29 0 27.718 19.579"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4col",
    width: 37.718,
    height: 19.579,
    x: 56.718
  })), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    id: "4col-view",
    viewBox: "56.718 0 37.718 19.579"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5col",
    width: 47.87,
    height: 19.579,
    x: 94.436
  })), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    id: "5col-view",
    viewBox: "94.436 0 47.87 19.579"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#accountDark",
    width: 16,
    height: 16,
    x: 142.306
  })), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    id: "accountDark-view",
    viewBox: "142.306 0 16 16"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#accountDarkV2",
    width: 16,
    height: 21,
    x: 158.306
  })), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    id: "accountDarkV2-view",
    viewBox: "158.306 12 16 21"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#accountLight",
    width: 16,
    height: 16,
    x: 174.306
  })), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    id: "accountLight-view",
    viewBox: "174.306 0 16 16"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert",
    width: 16,
    height: 16,
    x: 190.306
  })), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    id: "alert-view",
    viewBox: "190.306 0 16 16"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowDown",
    width: 10,
    height: 6,
    x: 206.306
  })), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    id: "arrowDown-view",
    viewBox: "206.306 0 10 6"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowDropdown",
    width: 10,
    height: 5,
    x: 216.306
  })), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    id: "arrowDropdown-view",
    viewBox: "216.306 0 10 5"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowDropdownLight",
    width: 10,
    height: 5,
    x: 226.306
  })), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    id: "arrowDropdownLight-view",
    viewBox: "226.306 0 10 5"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowLeft",
    width: 5.088,
    height: 9.085,
    x: 236.306
  })), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    id: "arrowLeft-view",
    viewBox: "236.306 0 5.088 9.085"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowRight",
    width: 5.088,
    height: 9.085,
    x: 241.394
  })), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    id: "arrowRight-view",
    viewBox: "241.394 0 5.088 9.085"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowRightWhite",
    width: 5.088,
    height: 9.085,
    x: 246.482
  })), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    id: "arrowRightWhite-view",
    viewBox: "246.482 0 5.088 9.085"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowUp",
    width: 10,
    height: 6,
    x: 251.57
  })), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    id: "arrowUp-view",
    viewBox: "251.57 0 10 6"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowUpWhite",
    width: 10,
    height: 6,
    x: 261.57
  })), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    id: "arrowUpWhite-view",
    viewBox: "261.57 0 10 6"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awesomeFont",
    width: 25.784,
    height: 25.784,
    x: 271.57
  })), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    id: "awesomeFont-view",
    viewBox: "271.57 0 25.784 25.784"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#awesomeFontLight",
    width: 25.784,
    height: 25.784,
    x: 297.354
  })), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    id: "awesomeFontLight-view",
    viewBox: "297.354 0 25.784 25.784"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#badge1",
    width: 53,
    height: 53,
    x: 323.138
  })), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    id: "badge1-view",
    viewBox: "323.138 0 53 53"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#badge2",
    width: 53,
    height: 53,
    x: 376.138
  })), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    id: "badge2-view",
    viewBox: "376.138 0 53 53"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#badge3",
    width: 53,
    height: 53,
    x: 429.138
  })), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    id: "badge3-view",
    viewBox: "429.138 0 53 53"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn-icon-success",
    width: 18.828,
    height: 13.414,
    x: 482.138
  })), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    id: "btn-icon-success-view",
    viewBox: "482.138 0 18.828 13.414"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#carouselPlus",
    width: 40,
    height: 27.84,
    x: 500.96599999999995
  })), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    id: "carouselPlus-view",
    viewBox: "500.96599999999995 0 40 27.84"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat",
    width: 16.667,
    height: 16.667,
    x: 540.9659999999999
  })), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    id: "chat-view",
    viewBox: "540.9659999999999 0 16.667 16.667"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkbox",
    width: 20,
    height: 20,
    x: 557.6329999999999
  })), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    id: "checkbox-view",
    viewBox: "557.6329999999999 0 20 20"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkboxSelected",
    width: 20,
    height: 20,
    x: 577.6329999999999
  })), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    id: "checkboxSelected-view",
    viewBox: "577.6329999999999 0 20 20"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkmark",
    width: 16,
    height: 16,
    x: 597.6329999999999
  })), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    id: "checkmark-view",
    viewBox: "597.6329999999999 0 16 16"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkmarkLight",
    width: 16,
    height: 16,
    x: 613.6329999999999
  })), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    id: "checkmarkLight-view",
    viewBox: "613.6329999999999 0 16 16"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkmarkNoCircle",
    width: 16,
    height: 16,
    x: 629.6329999999999
  })), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    id: "checkmarkNoCircle-view",
    viewBox: "629.6329999999999 0 16 16"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close",
    width: 9.333,
    height: 9.333,
    x: 645.6329999999999
  })), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    id: "close-view",
    viewBox: "645.6329999999999 0 9.333 9.333"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#embroideryNeedle",
    width: 15.998,
    height: 16,
    x: 654.9659999999999
  })), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    id: "embroideryNeedle-view",
    viewBox: "654.9659999999999 0 15.998 16"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#facebook",
    width: 20,
    height: 20,
    x: 670.9639999999999
  })), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    id: "facebook-view",
    viewBox: "670.9639999999999 0 20 20"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherFlag",
    width: 21.333,
    height: 26.167,
    x: 690.9639999999999
  })), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    id: "featherFlag-view",
    viewBox: "690.9639999999999 0 21.333 26.167"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherFlagLight",
    width: 21.333,
    height: 26.167,
    x: 712.2969999999999
  })), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    id: "featherFlagLight-view",
    viewBox: "712.2969999999999 0 21.333 26.167"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherFolder",
    width: 26.167,
    height: 23.75,
    x: 733.6299999999999
  })), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    id: "featherFolder-view",
    viewBox: "733.6299999999999 0 26.167 23.75"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherFolderLight",
    width: 26.167,
    height: 23.75,
    x: 759.7969999999999
  })), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    id: "featherFolderLight-view",
    viewBox: "759.7969999999999 0 26.167 23.75"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherImage",
    width: 24.405,
    height: 24.405,
    x: 785.9639999999999
  })), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    id: "featherImage-view",
    viewBox: "785.9639999999999 0 24.405 24.405"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#featherImageLight",
    width: 24.405,
    height: 24.405,
    x: 810.3689999999999
  })), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    id: "featherImageLight-view",
    viewBox: "810.3689999999999 0 24.405 24.405"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filter",
    width: 13,
    height: 12,
    x: 834.7739999999999
  })), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    id: "filter-view",
    viewBox: "834.7739999999999 0 13 12"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#footerPinterest",
    width: 30,
    height: 30,
    x: 847.7739999999999
  })), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    id: "footerPinterest-view",
    viewBox: "847.7739999999999 0 30 30"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fyl-prints-icon",
    width: 35,
    height: 35,
    x: 877.7739999999999
  })), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    id: "fyl-prints-icon-view",
    viewBox: "877.7739999999999 0 35 35"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#googlePlus",
    width: 20,
    height: 12.67,
    x: 912.7739999999999
  })), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    id: "googlePlus-view",
    viewBox: "912.7739999999999 0 20 12.67"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-feather-zoom-in",
    width: 30.621,
    height: 30.621,
    x: 932.7739999999999
  })), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    id: "icon-feather-zoom-in-view",
    viewBox: "932.7739999999999 0 30.621 30.621"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-feather-zoom-out",
    width: 30.621,
    height: 30.621,
    x: 963.3949999999999
  })), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    id: "icon-feather-zoom-out-view",
    viewBox: "963.3949999999999 0 30.621 30.621"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-feather-zoom-outLight",
    width: 30.621,
    height: 30.621,
    x: 994.0159999999998
  })), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    id: "icon-feather-zoom-outLight-view",
    viewBox: "994.0159999999998 0 30.621 30.621"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#irregular-badge",
    width: 74,
    height: 74,
    x: 1024.637
  })), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    id: "irregular-badge-view",
    viewBox: "1024.637 0 74 74"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#linkedin",
    width: 20,
    height: 20,
    x: 1098.637
  })), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    id: "linkedin-view",
    viewBox: "1098.637 0 20 20"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo",
    width: 543.999,
    height: 54.15,
    x: 1118.637
  })), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    id: "logo-view",
    viewBox: "1118.637 0 543.999 54.15"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoFooterPrimary",
    width: 180,
    height: 39.902,
    x: 1662.636
  })), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    id: "logoFooterPrimary-view",
    viewBox: "1662.636 0 180 39.902"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoFooterPrimaryChefUniform",
    width: 190.268,
    height: 39.466,
    x: 1842.636
  })), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    id: "logoFooterPrimaryChefUniform-view",
    viewBox: "1842.636 0 190.268 39.466"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoFooterPrimaryCorpSolutions",
    width: 282.851,
    height: 40.332,
    x: 2032.904
  })), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    id: "logoFooterPrimaryCorpSolutions-view",
    viewBox: "2032.904 0 282.851 40.332"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoFooterPrimaryWhite",
    width: 180,
    height: 39.902,
    x: 2315.755
  })), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    id: "logoFooterPrimaryWhite-view",
    viewBox: "2315.755 0 180 39.902"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoMobile",
    width: 200,
    height: 19.671,
    x: 2495.755
  })), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    id: "logoMobile-view",
    viewBox: "2495.755 0 200 19.671"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoTablet",
    width: 300,
    height: 29.507,
    x: 2695.755
  })), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    id: "logoTablet-view",
    viewBox: "2695.755 0 300 29.507"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuMobileDark",
    width: 24,
    height: 18.5,
    x: 2995.755
  })), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    id: "menuMobileDark-view",
    viewBox: "2995.755 0 24 18.5"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menuMobileLight",
    width: 18,
    height: 14,
    x: 3019.755
  })), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    id: "menuMobileLight-view",
    viewBox: "3019.755 0 18 14"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#minus",
    width: 18,
    height: 2,
    x: 3037.755
  })), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    id: "minus-view",
    viewBox: "3037.755 0 18 2"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#navLeft",
    width: 45,
    height: 45,
    x: 3055.755
  })), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    id: "navLeft-view",
    viewBox: "3055.755 0 45 45"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#navRight",
    width: 45,
    height: 45,
    x: 3100.755
  })), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    id: "navRight-view",
    viewBox: "3100.755 0 45 45"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#new-badge",
    width: 74,
    height: 74,
    x: 3145.755
  })), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    id: "new-badge-view",
    viewBox: "3145.755 0 74 74"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paypal-small",
    width: 19.454,
    height: 22.838,
    x: 3219.755
  })), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    id: "paypal-small-view",
    viewBox: "3219.755 0 19.454 22.838"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus",
    width: 18,
    height: 18,
    x: 3239.2090000000003
  })), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    id: "plus-view",
    viewBox: "3239.2090000000003 0 18 18"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plusWhite",
    width: 18,
    height: 18,
    x: 3257.2090000000003
  })), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    id: "plusWhite-view",
    viewBox: "3257.2090000000003 0 18 18"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#radio",
    width: 20,
    height: 19.997,
    x: 3275.2090000000003
  })), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    id: "radio-view",
    viewBox: "3275.2090000000003 0 20 19.997"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#radioSelected",
    width: 20,
    height: 19.997,
    x: 3295.2090000000003
  })), _view66 || (_view66 = /*#__PURE__*/React.createElement("view", {
    id: "radioSelected-view",
    viewBox: "3295.2090000000003 0 20 19.997"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rating",
    width: 14.857,
    height: 14.17,
    x: 3315.2090000000003
  })), _view67 || (_view67 = /*#__PURE__*/React.createElement("view", {
    id: "rating-view",
    viewBox: "3315.2090000000003 0 14.857 14.17"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ratingFull",
    width: 14.857,
    height: 14.17,
    x: 3330.0660000000003
  })), _view68 || (_view68 = /*#__PURE__*/React.createElement("view", {
    id: "ratingFull-view",
    viewBox: "3330.0660000000003 0 14.857 14.17"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ratingHalf",
    width: 14.857,
    height: 14.299,
    x: 3344.9230000000002
  })), _view69 || (_view69 = /*#__PURE__*/React.createElement("view", {
    id: "ratingHalf-view",
    viewBox: "3344.9230000000002 0 14.857 14.299"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search",
    width: 15.587,
    height: 15.587,
    x: 3359.78
  })), _view70 || (_view70 = /*#__PURE__*/React.createElement("view", {
    id: "search-view",
    viewBox: "3359.78 0 15.587 15.587"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shopMultiple",
    width: 21.047,
    height: 23,
    x: 3375.367
  })), _view71 || (_view71 = /*#__PURE__*/React.createElement("view", {
    id: "shopMultiple-view",
    viewBox: "3375.367 0 21.047 23"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shoppingBag",
    width: 17.395,
    height: 18.149,
    x: 3396.414
  })), _view72 || (_view72 = /*#__PURE__*/React.createElement("view", {
    id: "shoppingBag-view",
    viewBox: "3396.414 0 17.395 18.149"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#shoppingBagV2",
    width: 17.4,
    height: 18.15,
    x: 3413.809
  })), _view73 || (_view73 = /*#__PURE__*/React.createElement("view", {
    id: "shoppingBagV2-view",
    viewBox: "3413.809 12.43 17.4 18.15"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#slightly-irregular-badge",
    width: 74,
    height: 74,
    x: 3431.2090000000003
  })), _view74 || (_view74 = /*#__PURE__*/React.createElement("view", {
    id: "slightly-irregular-badge-view",
    viewBox: "3431.2090000000003 0 74 74"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#snapchat",
    width: 20,
    height: 18.766,
    x: 3505.2090000000003
  })), _view75 || (_view75 = /*#__PURE__*/React.createElement("view", {
    id: "snapchat-view",
    viewBox: "3505.2090000000003 0 20 18.766"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialFacebookDark",
    width: 10.407,
    height: 20.065,
    x: 3525.2090000000003
  })), _view76 || (_view76 = /*#__PURE__*/React.createElement("view", {
    id: "socialFacebookDark-view",
    viewBox: "3525.2090000000003 0 10.407 20.065"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialFacebookLight",
    width: 10.407,
    height: 20.065,
    x: 3535.6160000000004
  })), _view77 || (_view77 = /*#__PURE__*/React.createElement("view", {
    id: "socialFacebookLight-view",
    viewBox: "3535.6160000000004 0 10.407 20.065"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialInstagramDark",
    width: 19.785,
    height: 19.784,
    x: 3546.0230000000006
  })), _view78 || (_view78 = /*#__PURE__*/React.createElement("view", {
    id: "socialInstagramDark-view",
    viewBox: "3546.0230000000006 0 19.785 19.784"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialInstagramLight",
    width: 19.785,
    height: 19.784,
    x: 3565.8080000000004
  })), _view79 || (_view79 = /*#__PURE__*/React.createElement("view", {
    id: "socialInstagramLight-view",
    viewBox: "3565.8080000000004 0 19.785 19.784"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialPinterestDark",
    width: 20,
    height: 20,
    x: 3585.5930000000003
  })), _view80 || (_view80 = /*#__PURE__*/React.createElement("view", {
    id: "socialPinterestDark-view",
    viewBox: "3585.5930000000003 0 20 20"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialPinterestLight",
    width: 20,
    height: 20,
    x: 3605.5930000000003
  })), _view81 || (_view81 = /*#__PURE__*/React.createElement("view", {
    id: "socialPinterestLight-view",
    viewBox: "3605.5930000000003 0 20 20"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialTiktokLight",
    width: 17.314,
    height: 19.784,
    x: 3625.5930000000003
  })), _view82 || (_view82 = /*#__PURE__*/React.createElement("view", {
    id: "socialTiktokLight-view",
    viewBox: "3625.5930000000003 0 17.314 19.784"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialTwitterDark",
    width: 20.583,
    height: 16.908,
    x: 3642.907
  })), _view83 || (_view83 = /*#__PURE__*/React.createElement("view", {
    id: "socialTwitterDark-view",
    viewBox: "3642.907 0 20.583 16.908"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#socialTwitterLight",
    width: 20.583,
    height: 16.908,
    x: 3663.4900000000002
  })), _view84 || (_view84 = /*#__PURE__*/React.createElement("view", {
    id: "socialTwitterLight-view",
    viewBox: "3663.4900000000002 0 20.583 16.908"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sustainable",
    width: 19.302,
    height: 17.607,
    x: 3684.0730000000003
  })), _view85 || (_view85 = /*#__PURE__*/React.createElement("view", {
    id: "sustainable-view",
    viewBox: "3684.0730000000003 0 19.302 17.607"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tooltip",
    width: 18,
    height: 18,
    x: 3703.3750000000005
  })), _view86 || (_view86 = /*#__PURE__*/React.createElement("view", {
    id: "tooltip-view",
    viewBox: "3703.3750000000005 0 18 18"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash",
    width: 12.5,
    height: 13.728,
    x: 3721.3750000000005
  })), _view87 || (_view87 = /*#__PURE__*/React.createElement("view", {
    id: "trash-view",
    viewBox: "3721.3750000000005 0 12.5 13.728"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trashHover",
    width: 12.642,
    height: 17.604,
    x: 3733.8750000000005
  })), _view88 || (_view88 = /*#__PURE__*/React.createElement("view", {
    id: "trashHover-view",
    viewBox: "3733.8750000000005 0 12.642 17.604"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#upload",
    width: 23.75,
    height: 23.75,
    x: 3746.5170000000003
  })), _view89 || (_view89 = /*#__PURE__*/React.createElement("view", {
    id: "upload-view",
    viewBox: "3746.5170000000003 0 23.75 23.75"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uploadLight",
    width: 23.75,
    height: 23.75,
    x: 3770.2670000000003
  })), _view90 || (_view90 = /*#__PURE__*/React.createElement("view", {
    id: "uploadLight-view",
    viewBox: "3770.2670000000003 0 23.75 23.75"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wishlist",
    width: 26.11,
    height: 23.029,
    x: 3794.0170000000003
  })), _view91 || (_view91 = /*#__PURE__*/React.createElement("view", {
    id: "wishlist-view",
    viewBox: "3794.0170000000003 0 26.11 23.029"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wishlistSelected",
    width: 24.11,
    height: 21.029,
    x: 3820.1270000000004
  })), _view92 || (_view92 = /*#__PURE__*/React.createElement("view", {
    id: "wishlistSelected-view",
    viewBox: "3820.1270000000004 0 24.11 21.029"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#youtube",
    width: 19.996,
    height: 14.084,
    x: 3844.2370000000005
  })), _view93 || (_view93 = /*#__PURE__*/React.createElement("view", {
    id: "youtube-view",
    viewBox: "3844.2370000000005 0 19.996 14.084"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprites);
export default __webpack_public_path__ + "static/media/sprites.e67c893560ff152e15023f8b64aa03bc.svg";
export { ForwardRef as ReactComponent };